if (document.getElementById('treatment-tool')) {
    class getTranslationUtilities {
        getTranslation(text) {
            var curLang = localStorage.selectedLanguage;
            try {
                switch (text) {
                    case 'Let’s create your child’s <br class="d-lg-block d-none"> allergy profile':
                        return (curLang == 'en' ? 'Let’s create your child’s <br class="d-lg-block d-none"> allergy profile' : curLang == 'fr' ? 'Créons le profil d’allergie<br class="d-lg-block d-none"> de votre enfant' : '');
                    break;  
                    case 'Rate the impact of allergy symptoms <br class="d-lg-block d-none">while on current treatment':
                        return (curLang == 'en' ? 'Rate the impact of allergy symptoms <br class="d-lg-block d-none">while on current treatment' : curLang == 'fr' ? 'Évaluez l’incidence des symptômes d’allergie sous le traitement actuel' : '');
                    break;  
                    case 'NOT AFFECTED':
                        return (curLang == 'en' ? 'NOT AFFECTED' : curLang == 'fr' ? 'PAS INCOMMODÉ' : '');
                    break;  
                    case 'VERY AFFECTED':
                        return (curLang == 'en' ? 'VERY AFFECTED' : curLang == 'fr' ? 'TRÈS INCOMMODÉ' : '');
                    break;  
                    case 'Understand the scale':
                        return (curLang == 'en' ? 'Understand the scale' : curLang == 'fr' ? 'Comprendre l’échelle' : '');
                    break;  
                    case 'Select your <br class="d-lg-block d-none">child’s triggers':
                        return (curLang == 'en' ? 'Select your <br class="d-lg-block d-none">child’s triggers' : curLang == 'fr' ? 'Sélectionner les <br class="d-lg-block d-none"> déclencheurs de votre enfant' : '');
                    break;  
                    case 'Pollen':
                        return (curLang == 'en' ? 'Pollen' : curLang == 'fr' ? 'Pollen' : '');
                    break;  
                    case 'Dust mites':
                        return (curLang == 'en' ? 'Dust mites' : curLang == 'fr' ? 'Acariens' : '');
                    break;  
                    case 'Animals':
                        return (curLang == 'en' ? 'Animals' : curLang == 'fr' ? 'Animaux' : '');
                    break;  
                    case 'Mold':
                        return (curLang == 'en' ? 'Mold' : curLang == 'fr' ? 'Moisissures' : '');
                    break;  
                    case 'Other':
                        return (curLang == 'en' ? 'Other' : curLang == 'fr' ? 'Autre' : '');
                    break;  
                    case 'Don’t know':
                        return (curLang == 'en' ? 'Don’t know' : curLang == 'fr' ? 'Je ne sais pas' : '');
                    break;  
                    case 'unlock your <br> child’s allergy journey':
                        return (curLang == 'en' ? 'unlock your <br> child’s allergy journey' : curLang == 'fr' ? 'Découvrez le parcours de votre <br> enfant en matière d’allergies' : '');
                    break;  
                    case 'Has your child <br>seen an allergy specialist?':
                        return (curLang == 'en' ? 'Has your child <br>seen an allergy specialist?' : curLang == 'fr' ? 'Votre enfant a-t-il <br>consulté un allergologue?' : '');
                    break;  
                    case 'Did your child have an allergy test yet <br>to find out their trigger?':
                        return (curLang == 'en' ? 'Did your child have an allergy test yet <br class="d-none d-md-block">to find out their trigger?' : curLang == 'fr' ? 'Votre enfant a-t-il déjà passé un test <br class="d-none d-md-block">d’allergie pour déterminer ses déclencheurs?' : '');
                    break;  
                    case 'Are you aware of practical ways <br>to avoid allergy triggers in daily life?':
                        return (curLang == 'en' ? 'Are you aware of practical ways <br class="d-none d-md-block">to avoid allergy triggers in daily life?' : curLang == 'fr' ? 'Connaissez-vous des moyens pratiques d’éviter les <br class="d-none d-md-block"> facteurs déclencheurs d’allergies au quotidien?' : '');
                    break;  
                    case 'Has your child tried antihistamines, <br>corticosteroids or any other short-term relief?':
                        return (curLang == 'en' ? 'Has your child tried antihistamines, <br class="d-none d-md-block">corticosteroids or any other short-term relief?' : curLang == 'fr' ? 'Votre enfant a-t-il déjà pris des antihistaminiques, <br class="d-none d-md-block">des corticostéroïdes ou tout autre traitement à court terme?' : '');
                    break;  
                    case 'Has your doctor talked with you about <br>long-term relief with allergy immunotherapy?':
                        return (curLang == 'en' ? 'Has your doctor talked with you about <br class="d-none d-md-block">long-term relief with allergy immunotherapy?' : curLang == 'fr' ? 'Votre médecin vous a-t-il parlé des bienfaits <br class="d-none d-md-block"> à long terme de l’immunothérapie allergénique?' : ''); 
                    break;  
                    case 'Generate my results':
                        return (curLang == 'en' ? 'Generate my results' : curLang == 'fr' ? 'Générer mes résultats' : '');
                    break; 
                    case 'Satisfactory, for now':
                        return (curLang == 'en' ? 'Satisfactory, for now' : curLang == 'fr' ? 'Satisfaisant, pour l’instant' : '');
                    break;  
                    case "You’ve rated your child as unaffected by symptoms while on current treatment. But if you're worried, it's a good idea to discuss your child’s allergy with a doctor.":
                        return (curLang == 'en' ? "You’ve rated your child as unaffected by symptoms while on current treatment. But if you're worried, it's a good idea to discuss your child’s allergy with a doctor." : curLang == 'fr' ? 'Vous avez indiqué que votre enfant n’est pas du tout incommodé par ses symptômes sous le traitement actuel. Toutefois, si vous avez des inquiétudes, il est recommandé de discuter de l’allergie de votre enfant avec un médecin.' : '');
                    break;   
                    case 'Promising but not perfect':
                        return (curLang == 'en' ? 'Promising but not perfect' : curLang == 'fr' ? 'Prometteur, mais pas parfait ' : '');
                    break; 
                    case "You’ve rated your child as mildly affected by symptoms while on current treatment. But if you're worried, it's a good idea to discuss your child’s allergy with a doctor.":
                        return (curLang == 'en' ? "You’ve rated your child as mildly affected by symptoms while on current treatment. But if you're worried, it's a good idea to discuss your child’s allergy with a doctor." : curLang == 'fr' ? 'Vous avez indiqué que votre enfant est légèrement incommodé par ses symptômes malgré le traitement actuel. Toutefois, si vous avez des inquiétudes, il est recommandé de discuter de l’allergie de votre enfant avec un médecin.' : '');
                    break;  
                    case 'Room for improvement':
                        return (curLang == 'en' ? 'Room for improvement' : curLang == 'fr' ? 'Il y a des progrès à faire' : '');
                    break;  
                    case "You’ve rated your child as somewhat affected by symptoms while on current treatment. Keeping a symptom diary could help your doctor find the best allergy plan for your child.":
                        return (curLang == 'en' ? "You’ve rated your child as somewhat affected by symptoms while on current treatment. Keeping a symptom diary could help your doctor find the best allergy plan for your child." : curLang == 'fr' ? 'Vous avez indiqué que votre enfant est assez incommodé par ses symptômes malgré le traitement actuel. Tenez un journal des symptômes afin d’aider votre médecin à établir le meilleur plan de prise en charge des allergies pour votre enfant.' : '');
                    break;  
                    case 'May struggle without better support':
                        return (curLang == 'en' ? 'May struggle without better support' : curLang == 'fr' ? 'Pourrait rencontrer des difficultés sans un meilleur soutien' : '');
                    break;  
                    case "You’ve rated your child as significantly affected by symptoms while on current treatment. Keeping a symptom diary could help your doctor find the best allergy plan for your child.":
                        return (curLang == 'en' ? "You’ve rated your child as significantly affected by symptoms while on current treatment. Keeping a symptom diary could help your doctor find the best allergy plan for your child." : curLang == 'fr' ? 'Vous avez indiqué que votre enfant est très incommodé par ses symptômes malgré le traitement actuel. Tenez un journal des symptômes afin d’aider votre médecin à établir le meilleur plan de prise en charge des allergies pour votre enfant.' : '');
                    break;  
                    case "What’s next?":
                        return (curLang == 'en' ? "What’s next?" : curLang == 'fr' ? 'Et maintenant?' : '');
                    break;  
                    case "Check out the insights and tips below":
                        return (curLang == 'en' ? 'Check out the insights and tips below' : curLang == 'fr' ? 'Consultez les informations et les conseils ci-dessous' : '');
                    break;  
                    case "Send them to yourself as a handy eBooklet":
                        return (curLang == 'en' ? 'Send them to yourself as a handy eBooklet' : curLang == 'fr' ? 'Envoyez-les-vous sous forme de livret électronique pratique' : '');
                    break;  
                    case "And find the symptom diary and kids’ allergy medication guide inside":
                        return (curLang == 'en' ? "And find the symptom diary and kids’ allergy medication guide inside" : curLang == 'fr' ? 'Et découvrez le journal des symptômes et le guide sur les médicaments contre les allergies chez les enfants fournis dans le livret' : '');
                    break;  
                    case "Get the parents’ allergy kit":
                        return (curLang == 'en' ? "Get the parents’ allergy kit" : curLang == 'fr' ? 'Obtenir la trousse sur les allergies pour les parents' : '');
                    break;  
                    case "You’ve taken your child to see an allergy specialist":
                        return (curLang == 'en' ? "You’ve taken your child to see an allergy specialist" : curLang == 'fr' ? 'Vous avez emmené votre enfant chez un allergologue' : '');
                    break;  
                    case "If you want to get a second opinion you can always use our search tool to find a doctor":
                        return (curLang == 'en' ? 'If you want to get a second opinion you can always use our search tool to find a doctor' : curLang == 'fr' ? 'Si vous souhaitez obtenir un deuxième avis, vous pouvez toujours utiliser notre outil de recherche pour trouver un médecin.' : '');
                    break;  
                    case "You haven’t taken your child to see an allergy specialist yet":
                        return (curLang == 'en' ? "You haven’t taken your child to see an allergy specialist yet" : curLang == 'fr' ? 'Vous n’avez pas encore emmené votre enfant chez un allergologue' : '');
                    break;  
                    case "Allergists can order tests and prescribe stronger symptomatic meds and long-term allergy relief":
                        return (curLang == 'en' ? 'Allergists can order tests and prescribe prescription symptomatic meds and long-term allergy treatment' : curLang == 'fr' ? 'Les allergologues peuvent prescrire des tests, des médicaments sur ordonnance pour soulager les symptômes et des traitements à long terme contre les allergies.' : '');
                    break; 
                    case "Find a Doctor":
                        return (curLang == 'en' ? 'Find a Doctor' : curLang == 'fr' ? 'Trouver un médecin' : '');
                    break;   
                    case "Your child has had an allergy test":
                        return (curLang == 'en' ? 'Your child has had an allergy test' : curLang == 'fr' ? 'Votre enfant a déjà passé un test d’allergie' : '');
                    break;  
                    case "Tests look for current triggers. Ask about retesting your child if the first one was a while ago.":
                        return (curLang == 'en' ? 'Tests look for current triggers. Ask about retesting your child if the first one was a while ago.' : curLang == 'fr' ? 'Ces tests permettent de déterminer les facteurs déclenchants actuels. Demandez que votre enfant passe un nouveau test si le premier remonte à un certain temps. ' : '');
                    break;  
                    case "Your child hasn’t had an allergy test yet":
                        return (curLang == 'en' ? "Your child hasn’t had an allergy test yet" : curLang == 'fr' ? 'Votre enfant n’a pas encore passé de test d’allergie' : '');
                    break;  
                    case "Tests help pinpoint triggers, which is vital for managing allergies.":
                        return (curLang == 'en' ? 'Tests help pinpoint triggers, which is vital for managing allergies.' : curLang == 'fr' ? 'Ces tests permettent de déterminer les facteurs déclenchants, ce qui est essentiel pour prendre en charge les allergies.' : '');
                    break; 
                    case "Discover testing types":
                        return (curLang == 'en' ? 'Discover testing types' : curLang == 'fr' ? 'Découvrez les types de tests' : '');
                    break;   
                    case "Don’t expect a yes/no answer from your child’s tests. Your doctor will interpret the results alongside their medical history.":
                        return (curLang == 'en' ? "Don’t expect a yes/no answer from your child’s tests. Your doctor will interpret the results alongside their medical history." : curLang == 'fr' ? 'Ne vous attendez pas à obtenir une réponse binaire (oui/non) à l’issue des tests de votre enfant. Votre médecin interprétera les résultats en tenant compte de ses antécédents médicaux.' : '');
                    break;   
                    case "Skin prick test":
                        return (curLang == 'en' ? 'Skin prick test' : curLang == 'fr' ? 'Test cutané' : '');
                    break;   
                    case "Diluted allergens are dropped onto the child’s skin, which is gently pricked. A red bump like a mosquito bite is a reaction.":
                        return (curLang == 'en' ? "Diluted allergens are dropped onto the child’s skin, which is gently pricked. A red bump like a mosquito bite is a reaction." : curLang == 'fr' ? 'Des allergènes dilués sont déposés sur la peau de l’enfant, qui est ensuite piquée délicatement. Une bosse rouge semblable à une piqûre de moustique indique une réaction.' : '');
                    break;   
                    case "Allergy blood test":
                        return (curLang == 'en' ? 'Allergy blood test' : curLang == 'fr' ? 'Analyse sanguine' : '');
                    break;   
                    case "Blood tests check if children have IgE antibodies against different allergy triggers.":
                        return (curLang == 'en' ? 'Blood tests check if children have IgE antibodies against different allergy triggers.' : curLang == 'fr' ? 'Les analyses sanguines permettent de vérifier si les enfants possèdent des anticorps IgE dirigés contre différents déclencheurs d’allergies.' : '');
                    break;
                    case "You know how to help your child avoid their trigger":
                        return (curLang == 'en' ? 'You know how to help your child avoid their trigger' : curLang == 'fr' ? 'Vous savez comment aider votre enfant à éviter ses facteurs déclenchants' : '');
                    break; 
                    case "In case there’s something you haven’t tried yet here are some practical tips.":
                        return (curLang == 'en' ? "In case there’s something you haven’t tried yet here are some practical tips." : curLang == 'fr' ? 'Au cas où vous n’auriez pas encore tout essayé, voici quelques conseils pratiques.' : '');
                    break; 
                    case "You don’t know how to help your child avoid their trigger":
                        return (curLang == 'en' ? "You don’t know how to help your child avoid their trigger" : curLang == 'fr' ? 'Vous ne savez pas comment aider votre enfant à éviter ses facteurs déclenchants' : '');
                    break; 
                    case "Here are some practical tips to try, depending on what they react to.":
                        return (curLang == 'en' ? 'Here are some practical tips to try, depending on what they react to.' : curLang == 'fr' ? 'Voici quelques conseils pratiques à essayer, en fonction des facteurs déclenchants auxquels il réagit.' : '');
                    break; 
                    case "Minimising contact with the trigger is important but these particles are tiny and often invisible. So your child might still need allergy relief.":
                        return (curLang == 'en' ? 'Minimising contact with the trigger is important but these particles are tiny and often invisible. So your child might still need allergy treatment.' : curLang == 'fr' ? 'Il est important de minimiser le contact avec les facteurs déclenchants, mais ces particules sont minuscules et souvent invisibles. Votre enfant pourrait donc malgré tout avoir besoin d’un traitement contre les allergies.' : '');
                    break; 
                    case "Get more practical tips":
                        return (curLang == 'en' ? 'Get more practical tips' : curLang == 'fr' ? 'Obtenir plus de conseils pratiques' : '');
                    break; 
                    case "Practical tips for<br> pollen allergy":
                        return (curLang == 'en' ? 'Practical tips for<br> pollen allergy' : curLang == 'fr' ? 'Conseils pratiques pour<br> l’allergie au pollen' : '');
                    break; 
                    case "Check the pollen forecast daily.":
                        return (curLang == 'en' ? 'Check the pollen forecast daily.' : curLang == 'fr' ? 'Consultez quotidiennement les prévisions polliniques.' : '');
                    break; 
                    case "Get your child to wear a hat and sunglasses to shield their eyes from pollen.":
                        return (curLang == 'en' ? 'Get your child to wear a hat and sunglasses to shield their eyes from pollen.' : curLang == 'fr' ? 'Demandez à votre enfant de porter un chapeau et des lunettes de soleil pour protéger ses yeux du pollen.' : '');
                    break; 
                    case "Keep windows and doors closed unless the pollen count is low.":
                        return (curLang == 'en' ? 'Keep windows and doors closed unless the pollen count is low.' : curLang == 'fr' ? 'Gardez les fenêtres et les portes fermées, sauf si le taux de pollen est faible.' : '');
                    break; 
                    case "Get kids to change out of daytime clothes in the bathroom and wash their hair.":
                        return (curLang == 'en' ? 'Get kids to change out of daytime clothes in the bathroom and wash their hair.' : curLang == 'fr' ? 'Demandez à votre enfant de se changer dans la salle de bain et de se laver les cheveux.' : '');
                    break; 
                    case "Use a tumble dryer or hang laundry inside not outdoors.":
                        return (curLang == 'en' ? 'Use a tumble dryer or hang laundry inside not outdoors.' : curLang == 'fr' ? 'Utilisez la sécheuse ou étendez le linge à l’intérieur plutôt qu’à l’extérieur.' : '');
                    break; 
                    case "Practical tips for<br> dust mite allergy":
                        return (curLang == 'en' ? 'Practical tips for<br> dust mite allergy' : curLang == 'fr' ? 'Conseils pratiques pour<br> l’allergie aux acariens' : '');
                    break; 
                    case "Keep humidity below 50% in your home.":
                        return (curLang == 'en' ? 'Keep humidity below 50% in your home.' : curLang == 'fr' ? 'Maintenez le taux d’humidité de votre logement en dessous de 50 %.' : '');
                    break; 
                    case "Put mite-proof covers on your child’s mattress and bedding.":
                        return (curLang == 'en' ? "Put mite-proof covers on your child’s mattress and bedding." : curLang == 'fr' ? 'Mettez des housses anti-acariens sur le matelas et la literie de votre enfant.' : '');
                    break; 
                    case "Hot-wash bed linen weekly.":
                        return (curLang == 'en' ? 'Hot-wash bed linen weekly.' : curLang == 'fr' ? 'Lavez la literie à haute température chaque semaine.' : '');
                    break; 
                    case "Be aware of dust traps: Carpet, curtains, pet beds and laundry baskets.":
                        return (curLang == 'en' ? 'Be aware of dust traps: Carpet, curtains, pet beds and laundry baskets.' : curLang == 'fr' ? 'Faites attention aux nids à poussière : tapis, rideaux, paniers pour animaux et paniers à linge.' : '');
                    break; 
                    case "Pop stuffed toys regularly into the freezer for 48 hours.":
                        return (curLang == 'en' ? 'Pop stuffed toys regularly into the freezer for 48 hours.' : curLang == 'fr' ? 'Mettez régulièrement les peluches au congélateur pendant 48 heures.' : '');
                    break; 
                    case "Clean with a damp cloth and a vacuum with a HEPA filter.":
                        return (curLang == 'en' ? 'Clean with a damp cloth and a vacuum with a HEPA filter.' : curLang == 'fr' ? 'Nettoyez avec un chiffon humide et passez l’aspirateur muni d’un filtre HEPA.' : '');
                    break; 
                    case "Practical tips for<br> allergies to animals":
                        return (curLang == 'en' ? 'Practical tips for<br> allergies to animals' : curLang == 'fr' ? 'Conseils pratiques pour<br> les allergies aux animaux' : '');
                    break; 
                    case "Make your child’s bedroom a pet-free zone.":
                        return (curLang == 'en' ? "Make your child’s bedroom a pet-free zone." : curLang == 'fr' ? 'Faites de la chambre de votre enfant une zone sans animaux.' : '');
                    break; 
                    case "Teach them not to let animals lick them and to wash hands after contact.":
                        return (curLang == 'en' ? 'Teach them not to let animals lick them and to wash hands after contact.' : curLang == 'fr' ? 'Apprenez-lui à ne pas se laisser lécher par les animaux et à se laver les mains après tout contact.' : '');
                    break; 
                    case "Make changing clothes the routine anytime they’ve been with an animal.":
                        return (curLang == 'en' ? "Make changing clothes the routine anytime they’ve been with an animal." : curLang == 'fr' ? 'Prévoyez de changer ses vêtements systématiquement après chaque contact avec un animal.' : '');
                    break; 
                    case "Use a vacuum fitted with a HEPA filter.":
                        return (curLang == 'en' ? 'Use a vacuum fitted with a HEPA filter.' : curLang == 'fr' ? 'Utilisez un aspirateur muni d’un filtre HEPA.' : '');
                    break; 
                    case "Wash pets and their beds regularly.":
                        return (curLang == 'en' ? 'Wash pets and their beds regularly.' : curLang == 'fr' ? 'Lavez régulièrement les animaux et leurs lits. ' : '');
                    break; 
                    case "Practical tips for<br> mold allergy":
                        return (curLang == 'en' ? 'Practical tips for<br> mold allergy' : curLang == 'fr' ? 'Conseils pratiques pour<br> l’allergie aux moisissures' : '');
                    break; 
                    case "Discourage kids from playing in damp autumn leaves.":
                        return (curLang == 'en' ? 'Discourage kids from playing in damp autumn leaves.' : curLang == 'fr' ? 'Dissuadez les enfants de jouer dans les feuilles d’automne humides. ' : '');
                    break; 
                    case "Leave coats and outdoor shoes by the door.":
                        return (curLang == 'en' ? 'Leave coats and outdoor shoes by the door.' : curLang == 'fr' ? 'Laissez les manteaux et les chaussures d’extérieur près de la porte.' : '');
                    break; 
                    case "Keep humidity below 50% at home.":
                        return (curLang == 'en' ? 'Keep humidity below 50% at home.' : curLang == 'fr' ? 'Maintenez le taux d’humidité de votre logement en dessous de 50 %.' : '');
                    break; 
                    case "Ventilate well, especially the kitchen and bathroom.":
                        return (curLang == 'en' ? 'Ventilate well, especially the kitchen and bathroom.' : curLang == 'fr' ? 'Aérez bien votre logement, en particulier la cuisine et la salle de bain.' : '');
                    break; 
                    case "Clean mold hot spots: rubber seals; refrigerator drip-pans; window frames; and the bathroom.":
                        return (curLang == 'en' ? 'Clean mold hot spots: rubber seals; refrigerator drip-pans; window frames; and the bathroom.' : curLang == 'fr' ? 'Nettoyez les endroits propices à la moisissure : joints en caoutchouc, bacs de récupération du réfrigérateur, encadrements de fenêtres et salle de bain.' : '');
                    break; 
                    case "Your child has tried short-term relief":
                        return (curLang == 'en' ? 'Your child has tried short-term treatment' : curLang == 'fr' ? 'Votre enfant a suivi un traitement à court terme' : '');
                    break; 
                    case "If that medication isn’t working, it may be time to try something different. Track your child’s symptoms and medication in our diary to show the doctor.":
                        return (curLang == 'en' ? "If that medication isn’t working, it may be time to try something different. Track your child’s symptoms and medication in our diary to show the doctor." : curLang == 'fr' ? 'Si ce médicament ne fonctionne pas, il est peut-être temps d’essayer autre chose. Notez les symptômes et les médicaments de votre enfant dans notre journal afin de les montrer au médecin.' : '');
                    break; 
                    case "Your child hasn’t tried short-term relief medication yet":
                        return (curLang == 'en' ? "Your child hasn’t tried short-term relief medication yet" : curLang == 'fr' ? 'Votre enfant n’a pas encore essayé de traitement à court terme' : '');
                    break; 
                    case "Track your child’s symptoms in our diary and show your doctor who can guide you.":
                        return (curLang == 'en' ? "Track your child’s symptoms in our diary and show your doctor who can guide you." : curLang == 'fr' ? 'Notez les symptômes de votre enfant dans notre journal et montrez-le à votre médecin, qui pourra vous conseiller.' : '');
                    break; 
                    case "Learn more about Short-term relief":
                        return (curLang == 'en' ? 'Learn more about Short-term treatments' : curLang == 'fr' ? 'En savoir plus sur les traitements à court terme' : '');
                    break; 
                    case "Antihistamines, <br>corticosteroids, <br>decongestants and so on":
                        return (curLang == 'en' ? 'Antihistamines, <br>corticosteroids, <br>decongestants and so on' : curLang == 'fr' ? 'Antihistaminiques, corticostéroïdes, etc.' : '');
                    break; 
                    case "for short-term relief":
                        return (curLang == 'en' ? 'for short-term relief' : curLang == 'fr' ? 'pour un soulagement à court terme' : '');
                    break; 
                    case "Short-term relief can block or calm symptoms temporarily.":
                        return (curLang == 'en' ? 'Short-term treatments can block or calm symptoms temporarily.' : curLang == 'fr' ? 'Les traitements à court terme peuvent bloquer ou apaiser temporairement les symptômes.' : '');
                    break; 
                    case "Best taken before the reaction starts; your child may also need medication any time they’re exposed to their trigger.":
                        return (curLang == 'en' ? "Best taken before the reaction starts; your child may also need medication any time they’re exposed to their trigger." : curLang == 'fr' ? 'Il est préférable de les prendre avant l’apparition des symptômes; votre enfant peut également avoir besoin de médicaments dès qu’il est exposé à son facteur déclenchant.' : '');
                    break; 
                    case "Topical forms include nasal sprays, eye drops, creams, lotions, gels and inhalers.":
                        return (curLang == 'en' ? 'Topical forms include nasal sprays and eye drops.' : curLang == 'fr' ? 'Les formes topiques comprennent les vaporisateurs nasaux et les gouttes oculaires.' : '');
                    break; 
                    case "Tablets, capsules, liquids or syrups are usually for stronger or multiple symptoms.":
                        return (curLang == 'en' ? 'Tablets, capsules, liquids or syrups, and other forms that can be taken by mouth are also available. These are usually for stronger or multiple symptoms.' : curLang == 'fr' ? 'Des comprimés, des gélules, des solutions buvables ou des sirops, ainsi que d’autres préparations administrées par voie orale, sont également offerts sur le marché. Ces traitements sont généralement destinés à soulager des symptômes plus sévères ou multiples.' : '');
                    break; 
                    case "If it isn’t working, your doctor can suggest a different antihistamine or corticosteroid. There are different kinds and it might be worth checking another one out.":
                        return (curLang == 'en' ? 'If it isn’t working, your doctor can suggest a different antihistamine or corticosteroid. There are different kinds and it might be worth checking another one out.' : curLang == 'fr' ? 'Si ces traitements ne fonctionnent pas, votre médecin peut vous proposer un autre antihistaminique ou un autre corticostéroïde. Il en existe différents types et il peut être utile d’en essayer un autre. ' : '');
                    break; 
                    case "You already know about allergy immunotherapy":
                        return (curLang == 'en' ? 'You already know about allergy immunotherapy' : curLang == 'fr' ? 'Vous connaissez déjà l’immunothérapie allergénique' : '');
                    break; 
                    case "Would you like to see how this might fit into a child’s allergy treatment plan?":
                        return (curLang == 'en' ? "Would you like to see how this might fit into a child’s allergy treatment plan?" : curLang == 'fr' ? 'Souhaitez-vous savoir comment cette option pourrait s’intégrer au plan de traitement des allergies de votre enfant?' : '');
                    break; 
                    case "You don’t know about allergy immunotherapy":
                        return (curLang == 'en' ? "You don’t know about allergy immunotherapy" : curLang == 'fr' ? 'Vous ne connaissez pas l’immunothérapie allergénique' : '');
                    break; 
                    case "This treatment aims to train the immune system not to react to an allergy trigger.":
                        return (curLang == 'en' ? 'This treatment aims to train the immune system not to react to an allergy trigger.' : curLang == 'fr' ? 'Ce traitement vise à entraîner le système immunitaire à ne pas réagir à un déclencheur d’allergies.' : '');
                    break; 
                    case "Understand allergy immunotherapy":
                        return (curLang == 'en' ? 'Understand allergy immunotherapy' : curLang == 'fr' ? 'Comprendre l’immunothérapie allergénique' : '');
                    break; 
                    case "Allergy <br>immunotherapy":
                        return (curLang == 'en' ? 'Allergy <br>immunotherapy' : curLang == 'fr' ? 'L’immunothérapie <br>allergénique' : '');
                    break; 
                    case "for long-term relief":
                        return (curLang == 'en' ? 'for long-term relief' : curLang == 'fr' ? 'pour un soulagement à long terme' : '');
                    break; 
                    case "This treatment tackles the root cause of a child’s allergy.":
                        return (curLang == 'en' ? "This treatment tackles the root cause of a child’s allergy." : curLang == 'fr' ? 'Ce traitement s’attaque à la cause profonde de l’allergie de l’enfant.' : '');
                    break; 
                    case "Regular controlled doses of a trigger like pollen or dust mites help build a natural tolerance.":
                        return (curLang == 'en' ? 'Regular controlled doses of a trigger like pollen or dust mites help build a natural tolerance.' : curLang == 'fr' ? 'L’administration régulière de doses contrôlées d’un allergène, tel que le pollen ou les acariens, aide à développer une tolérance.' : '');
                    break; 
                    case "Allergy immunotherapy comes as tablets or shots depending on a child’s age and allergy.":
                        return (curLang == 'en' ? "Allergy immunotherapy comes as tablets that dissolve under the tongue or shots depending on a child’s age and allergy." : curLang == 'fr' ? 'L’immunothérapie allergénique se présente sous forme de comprimés qui se dissolvent sous la langue ou d’injections, selon l’âge de l’enfant et le type d’allergie.' : '');
                    break; 
                    case "The goal is to reduce symptoms and the need for regular allergy meds during and after treatment.":
                        return (curLang == 'en' ? 'The goal is to reduce symptoms and the need for regular symptomatic allergy meds during and after treatment.' : curLang == 'fr' ? 'L’objectif du traitement est de réduire les symptômes et le recours régulier à des médicaments contre les allergies pendant et après le traitement.' : '');
                    break; 
                    case "You’ll shortly be getting a confirmation email. Please click on the link in the email so we know it’s really you. Then we’ll send the report.":
                        return (curLang == 'en' ? "You’ll shortly be getting a confirmation email. Please click on the link in the email so we know it’s really you. Then we’ll send the report." : curLang == 'fr' ? 'Vous recevrez sous peu un courriel de confirmation. Veuillez cliquer sur le lien contenu dans le courriel afin que nous puissions vérifier qu’il s’agit bien de vous. Nous vous enverrons ensuite le bilan.' : '');
                    break; 
                    case "Your child's report has been sent now. Thank you for doing the Allergy Treatment Review.":
                        return (curLang == 'en' ? "Your child's report has been sent now. Thank you for doing the Allergy Treatment Review." : curLang == 'fr' ? 'Le bilan de votre enfant vient d’être envoyé. Merci d’avoir rempli le bilan du traitement des allergies.' : '');
                    break; 
                }
            }
            catch (e) {
                console.error(e);
            }
        }
    }
  var getTranslationUtility = new getTranslationUtilities();

  window.treatmentTool = {
    questions: [
      {
          question: getTranslationUtility.getTranslation('Rate the impact of allergy symptoms <br class="d-lg-block d-none">while on current treatment'),
          category: 'vas',
      },
      {
          question: getTranslationUtility.getTranslation('Select your <br class="d-lg-block d-none">child’s triggers'),
          category: 'triggers',
          multipleOptions: [
              {
                  title: getTranslationUtility.getTranslation('Pollen'),
              },
              {
                  title: getTranslationUtility.getTranslation('Dust mites'),
              },
              {
                  title: getTranslationUtility.getTranslation('Animals'),
              },
              {
                  title: getTranslationUtility.getTranslation('Mold'),
              },
              {
                  title: getTranslationUtility.getTranslation('Other'),
              },
              {
                  title: getTranslationUtility.getTranslation('Don’t know'),
                  disable: true,
              }
          ]
      },
      {
          question: getTranslationUtility.getTranslation('Has your child <br>seen an allergy specialist?'),
          category: 'boolean',
          answerOptions: [
              {
                  title: 'yes',
                  icon:'icon-tick-1',
              },
              {
                  title: 'no',
                  icon: 'icon-close-5',
              }
          ]
      },
      {
          question: getTranslationUtility.getTranslation('Did your child have an allergy test yet <br>to find out their trigger?'),
          category: 'boolean',
          answerOptions: [
              {
                  title: 'yes',
                  icon:'icon-tick-1',
              },
              {
                  title: 'no',
                  icon: 'icon-close-5',
              }
          ]
      },
      {
          question: getTranslationUtility.getTranslation('Are you aware of practical ways <br>to avoid allergy triggers in daily life?'),
          category: 'boolean',
          answerOptions: [
              {
                  title: 'yes',
                  icon:'icon-tick-1',
              },
              {
                  title: 'no',
                  icon: 'icon-close-5',
              }
          ]
      },
      {
          question: getTranslationUtility.getTranslation('Has your child tried antihistamines, <br>corticosteroids or any other short-term relief?'),
          category: 'boolean',
          answerOptions: [
              {
                  title: 'yes',
                  icon:'icon-tick-1',
              },
              {
                  title: 'no',
                  icon: 'icon-close-5',
              }
          ]
      },
      {
          question: getTranslationUtility.getTranslation('Has your doctor talked with you about <br>long-term relief with allergy immunotherapy?'),
          category: 'boolean',
          answerOptions: [
              {
                  title: 'yes',
                  icon:'icon-tick-1',
              },
              {
                  title: 'no',
                  icon: 'icon-close-5',
              }
          ]
      }
    ],
    indicatorImages: [
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_green_blob_test.svg',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_orange_blob_test.svg',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_red_blob_test.svg',
    ],
    indicatorQueImages: [
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/blob_animation_blue_new.gif?v=1748858386',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/blob_animation_turquoise_new.gif?v=1748858385',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/blob_animation_yellow_new.gif?v=1748858386',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/blob_animation_red_new.gif?v=1748858387',
    ],
    indicatorAnsImages: [
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_Drop_Pin_Blob_-_Blue.png?v=1747645814',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_Drop_Pin_Blob_-_Turqoise.png?v=1747645814',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_Drop_Pin_Blob_-_Orange.png?v=1747645815',
        'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_Drop_Pin_Blob_-_Red.png?v=1747645815',
    ],
    answers: [
      {
          question: '',
          answer: [],
          category: '',
          vas_score: null
      },
      {
          question: '',
          answer: [],
          category: '',
          vas_score: null
      },
      {
          question: '',
          answer: [],
          category: '',
          vas_score: null
      },
      {
          question: '',
          answer: [],
          category: '',
          vas_score: null
      },
      {
          question: '',
          answer: [],
          category: '',
          vas_score: null
      },
      {
          question: '',
          answer: [],
          category: '',
          vas_score: null
      },
      {
          question: '',
          answer: [],
          category: '',
          vas_score: null
      }
    ],
    booleanAns: [],
    answersContent: [
      {
          yesHeading: '',
          yesText: '',
          noHeading: '',
          noText: '',
      },
      {
          accordionHeading: getTranslationUtility.getTranslation('Find a Doctor'),
          yesHeading: getTranslationUtility.getTranslation('You’ve taken your child to see an allergy specialist'),
          yesText: getTranslationUtility.getTranslation('If you want to get a second opinion you can always use our search tool to find a doctor'),
          noHeading: getTranslationUtility.getTranslation('You haven’t taken your child to see an allergy specialist yet'),
          noText: getTranslationUtility.getTranslation('Allergists can order tests and prescribe stronger symptomatic meds and long-term allergy relief'),
      },
      {
          accordionHeading: getTranslationUtility.getTranslation('Discover testing types'),
          yesHeading: getTranslationUtility.getTranslation('Your child has had an allergy test'),
          yesText: getTranslationUtility.getTranslation('Tests look for current triggers. Ask about retesting your child if the first one was a while ago.'),
          noHeading: getTranslationUtility.getTranslation('Your child hasn’t had an allergy test yet'),
          noText: getTranslationUtility.getTranslation('Tests help pinpoint triggers, which is vital for managing allergies.'),
          bottomDescription: getTranslationUtility.getTranslation('Don’t expect a yes/no answer from your child’s tests. Your doctor will interpret the results alongside their medical history.'),
      },
      {
          accordionHeading: getTranslationUtility.getTranslation('Get more practical tips'),
          yesHeading: getTranslationUtility.getTranslation('You know how to help your child avoid their trigger'),
          yesText: getTranslationUtility.getTranslation('In case there’s something you haven’t tried yet here are some practical tips.'),
          noHeading: getTranslationUtility.getTranslation('You don’t know how to help your child avoid their trigger'),
          noText: getTranslationUtility.getTranslation('Here are some practical tips to try, depending on what they react to.'),
          bottomDescription: getTranslationUtility.getTranslation('Minimising contact with the trigger is important but these particles are tiny and often invisible. So your child might still need allergy relief.'),
      },
      {
          accordionHeading: getTranslationUtility.getTranslation('Learn more about Short-term relief'),
          yesHeading: getTranslationUtility.getTranslation('Your child has tried short-term relief'),
          yesText: getTranslationUtility.getTranslation('If that medication isn’t working, it may be time to try something different. Track your child’s symptoms and medication in our diary to show the doctor.'),
          noHeading: getTranslationUtility.getTranslation('Your child hasn’t tried short-term relief medication yet'),
          noText: getTranslationUtility.getTranslation('Track your child’s symptoms in our diary and show your doctor who can guide you.'),
      },
      {
          accordionHeading: getTranslationUtility.getTranslation('Understand allergy immunotherapy'),
          yesHeading: getTranslationUtility.getTranslation('You already know about allergy immunotherapy'),
          yesText: getTranslationUtility.getTranslation('Would you like to see how this might fit into a child’s allergy treatment plan?'),
          noHeading: getTranslationUtility.getTranslation('You don’t know about allergy immunotherapy'),
          noText: getTranslationUtility.getTranslation('This treatment aims to train the immune system not to react to an allergy trigger.'),
      },
    ],
    answerStorage: [],
    highestVASColor: '#009DC1',
    imageCharacter: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
    imageAnsCharacter: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg',
    imageQueCharacter: 'https://cdn.shopify.com/s/files/1/0605/5156/1273/files/blob_animation_yellow.gif?v=1747641460',
    reportHeading: "Your child doesn't seem affected",
    reportText: "You've rated their symptoms as zero impact. But if you're worried, it's a good idea to discuss the full report with your doctor.",
    signupForm: document.querySelector('#braze-form-main form'),
    unsavedChanges: true,
    knownUser: false,
    newsletterSignupVal: 'off',
    indicatorPopUp: document.querySelector('.indicator-value-overlay'),
    closeQuizPopup: document.querySelector('[data-close-quiz-popup]'),
    progressBar: null,
    clickedLink: 'https://ca.klarify.me',
    TOTID_Cookie: null,
    TOT_email: null,
   
    init() {
      // this.initSliders();
      this.setQuestionHTML();

      let newsletterSignupCheckbox = document.querySelector('.braze-form-container.signup .newsletter_signup_checkbox');

      if (this.getCookie('TOTID_Cookie') != '' && this.getCookie('TOTID_Cookie') != null && this.getCookie('TOTID_Cookie') != 'TOTID_Cookie') {
        this.TOTID_Cookie = this.getCookie('TOTID_Cookie');
      }
      else {
        this.TOTID_Cookie = localStorage.getItem('TOTID_Cookie');
      }

      if (this.TOTID_Cookie != null) {
          this.knownUser = true;
          newsletterSignupCheckbox.classList.add('d-none');
      }
      else {
          this.knownUser = false;
      }

      window.addEventListener('scroll', () => {
        this.checkLandingTile();
      });

      //start quiz
      document.querySelector('#start-quiz').addEventListener('click', async (event) => {
        event.preventDefault();
        if(document.querySelector('input[name="user_consent"]').checked && document.querySelector('input[name="person_authentication"]').checked) {
          let headerHeight = document.querySelector('.site-header').offsetHeight;
          // document.getElementById("treatment-tool-quiz").setAttribute('style', `scroll-margin-top:${parseInt(headerHeight)+35}px;`);
          // document.getElementById("treatment-tool-quiz").scrollIntoView();

          if(window.innerWidth < 768) {
            document.getElementById('treatment-tool-landing-tile').classList.add('hide');
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth' 
            });
          }
          else {
            let headerHeight = document.querySelector('.site-header').offsetHeight;
            document.querySelector(".treatment-tool-question .treatment-tool-initial-que-ans").setAttribute('style', `scroll-margin-top:${parseInt(headerHeight)+20}px;`);
            document.querySelector(".treatment-tool-question .treatment-tool-initial-que-ans").scrollIntoView({ behavior: 'smooth' });
            setTimeout(() => {
              document.getElementById("treatment-tool-landing-tile").classList.add('hide');
              if (navigator.userAgent.indexOf("Firefox") > 0) {
                window.scrollBy(0, 1);
              }
            }, 1000); 
          }

          document.querySelectorAll('.treatment-tool-question .treatment-tool-initial-que-ans input').forEach(input => {
            input.removeAttribute('disabled');
          });
          document.querySelector('.treatment-tool-initial-que-ans .scale-container .disable-slider').classList.add('d-none');

          window.dataLayer.push({
            'event': 'tot_started_consent_yes'
          });
        }
        else {
          if(!document.querySelector('input[name="user_consent"]').checked && !document.querySelector('input[name="person_authentication"]').checked) {
            document.querySelector('.treatment-tool-landing-tile .consent_checkbox .custom-checkmark').classList.add('required');
            document.querySelector('.treatment-tool-landing-tile .consent_checkbox').classList.add('bounce-effect');
            document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext .custom-checkmark').classList.add('required');
            document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext').classList.add('bounce-effect');
            document.querySelector('.treatment-tool-landing-tile .required-field').classList.add('bounce-effect');
            setTimeout(function() {
              document.querySelector('.treatment-tool-landing-tile .consent_checkbox .custom-checkmark').classList.remove('required');
              document.querySelector('.treatment-tool-landing-tile .consent_checkbox').classList.remove('bounce-effect');
              document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext .custom-checkmark').classList.remove('required');
              document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext').classList.remove('bounce-effect');
              document.querySelector('.treatment-tool-landing-tile .required-field').classList.remove('bounce-effect');
            },2000);
          }
          else if(!document.querySelector('input[name="user_consent"]').checked) { 
            document.querySelector('.treatment-tool-landing-tile .consent_checkbox .custom-checkmark').classList.add('required');
            document.querySelector('.treatment-tool-landing-tile .consent_checkbox').classList.add('bounce-effect');
            document.querySelector('.treatment-tool-landing-tile .required-field').classList.add('bounce-effect');
            setTimeout(function() {
              document.querySelector('.treatment-tool-landing-tile .consent_checkbox .custom-checkmark').classList.remove('required');
              document.querySelector('.treatment-tool-landing-tile .consent_checkbox').classList.remove('bounce-effect');
              document.querySelector('.treatment-tool-landing-tile .required-field').classList.remove('bounce-effect');
            },2000);
          }
          else {
            document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext .custom-checkmark').classList.add('required');
            document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext').classList.add('bounce-effect');
            document.querySelector('.treatment-tool-landing-tile .required-field').classList.add('bounce-effect');
            setTimeout(function() {
              document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext .custom-checkmark').classList.remove('required');
              document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext').classList.remove('bounce-effect');
              document.querySelector('.treatment-tool-landing-tile .required-field').classList.remove('bounce-effect');
            },2000);
          }

          window.dataLayer.push({
            'event': 'tot_started_consent_no'
          });
        }
      });

      // set blog image based on vas score
      document.querySelectorAll('.treatment-tool-question input[type="range"]').forEach(slider => {
        slider.addEventListener('change', (e) => {
          let parentElement = e.currentTarget.closest('.scale-container');
          let imageElement = parentElement.querySelector('img');
          if (e.currentTarget.value == 0) {
              imageElement.src = this.indicatorImages[0];
              this.imageQueCharacter = this.indicatorQueImages[0];
          }
          if (e.currentTarget.value == 1) {
              imageElement.src = this.indicatorImages[1];
               this.imageQueCharacter = this.indicatorQueImages[1];
          }
          if (e.currentTarget.value < 5 && e.currentTarget.value > 1) {
              imageElement.src = this.indicatorImages[2];
               this.imageQueCharacter = this.indicatorQueImages[2];
          }
          if (e.currentTarget.value > 4) {
              imageElement.src = this.indicatorImages[3];
               this.imageQueCharacter = this.indicatorQueImages[3];
          }

          document.querySelectorAll('.treatment-tool-question .boolean-que-ans').forEach((booleanQue) => {
            booleanQue.querySelector('.active-blob').setAttribute('src',this.imageQueCharacter);
          });

          this.checkLandingTile();

        });
      });

      // triggers condtion + active unlock questions btn 
      document.querySelectorAll('.treatment-tool-question .symptoms-container input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
            let inputName = e.currentTarget.name;
            let currentQuestionCheckboxes = document.querySelectorAll(`input[name="${inputName}"]`);
            if (e.currentTarget.hasAttribute("data-none-option")) {
                if (e.currentTarget.checked) {
                    currentQuestionCheckboxes.forEach(currentQuestionCheckbox => {
                        if (!currentQuestionCheckbox.hasAttribute("data-none-option")) {
                            currentQuestionCheckbox.checked = false
                        }
                    });
                }
            }
            else {
                currentQuestionCheckboxes.forEach(currentQuestionCheckbox => {
                    if (currentQuestionCheckbox.hasAttribute("data-none-option")) {
                        currentQuestionCheckbox.checked = false;
                    }
                });
            }
            if(document.querySelectorAll('.treatment-tool-question .symptoms-container input[type="checkbox"]:checked').length > 0) {
              document.getElementById('unlock-question').classList.remove('disabled');
            }
            else {
              document.getElementById('unlock-question').classList.add('disabled');
            }

            this.checkLandingTile();
        });
      });

      // unlock boolean questions + get indicator scale score + triggers selected 
      document.getElementById('unlock-question').addEventListener('click', async (event) => { 
        if(!document.getElementById('treatment-tool-landing-tile').classList.contains('hide')) {
            this.scrollToInitialTile();
        }
        else if(document.getElementById('unlock-question').classList.contains('disabled')) {
          this.scrollZoomToInitialQue();
        }
        else {
          if(!event.target.classList.contains('answered')){
            event.target.classList.add('answered');
            let vasQueScore = parseInt(document.querySelector('.treatment-tool-question input[type="range"]').value);
            // console.log('vasQueScore:');
            // console.log(vasQueScore);
            if (vasQueScore == 0) {
                this.imageQueCharacter = this.indicatorQueImages[0];
            }
            if (vasQueScore == 1) {
                this.imageQueCharacter = this.indicatorQueImages[1];
            }
            if (vasQueScore < 5 && vasQueScore > 1) {
                this.imageQueCharacter = this.indicatorQueImages[2];
            }
            if (vasQueScore > 4) {
                this.imageQueCharacter = this.indicatorQueImages[3];
            }
            document.querySelectorAll('.treatment-tool-question .boolean-que-ans').forEach((booleanQue) => {
              booleanQue.querySelector('.active-blob').setAttribute('src',this.imageQueCharacter);
            });

            document.querySelector('.treatment-tool-question .boolean-que-ans[data-options="question-1"]').scrollIntoView({
              behavior: 'smooth',
              block: 'center',
              inline: 'center'
            });
            document.querySelector('.treatment-tool-question .boolean-que-ans[data-options="question-1"]').classList.add('active');
            document.querySelectorAll('.treatment-tool-question .boolean-que-ans[data-options="question-1"] input[type="radio"]').forEach(radio => {
              radio.removeAttribute('disabled');
            });

            if(this.progressBar != null){
              this.progressBar.style.width = 20 + "%";
            } 
          }
        }

        window.dataLayer.push({
          'event': 'tot_cta_click'
        });
      });

      // disable btns click
      document.querySelectorAll('.treatment-tool-question .symptoms-container label').forEach(label => {
        label.addEventListener('click', async (event) => {
            if(event.target.closest('label').querySelector('input').hasAttribute('disabled')){
              this.scrollToInitialTile();
            }
        });
      });
      document.querySelector('.treatment-tool-question .disable-slider').addEventListener('click', async (event) => {
        this.scrollToInitialTile();
      });
      document.querySelectorAll('.treatment-tool-question .boolean-que-ans label.checkbox-item').forEach(checkboxItem => {
        checkboxItem.addEventListener('click', async (event) => {
          if(!document.getElementById('treatment-tool-landing-tile').classList.contains('hide')) {
             if(event.target.querySelector('input').hasAttribute('disabled')){
              this.scrollToInitialTile();
            }
          }
          else if(document.getElementById('unlock-question').classList.contains('disabled')) {
            if(event.target.querySelector('input').hasAttribute('disabled')){
              this.scrollZoomToInitialQue();
            }
          }
          else if(!document.getElementById('unlock-question').classList.contains('answered')) {
              document.getElementById("unlock-question").scrollIntoView({
                behavior: "smooth",
                block:  "center",
                inline: "center",
              });
              setTimeout(function(){
                document.querySelector(".treatment-tool-main .unlock-question").classList.add('pulse-effect');
              },300);
              setTimeout(function(){
                document.querySelector(".treatment-tool-main .unlock-question").classList.remove('pulse-effect');
              },1500);
          }
          else {
            if(document.getElementById('unlock-question').classList.contains('answered')){
              document.querySelector(".treatment-tool-boolean-que-ans .boolean-que-ans.active").scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
              });
            }
          }
        });
      });
     
      // get boolean answsers + active generate result
      document.querySelectorAll('.treatment-tool-question .boolean-que-ans').forEach((booleanQue, booleanQueIndex) => {
        let progressIndex = booleanQueIndex + 1;
        let progress = 20 + (16 * progressIndex);
        let currentQueOpt = booleanQue.getAttribute('data-options');
        booleanQue.querySelectorAll('input[type="radio"]').forEach(radioInput => {
          radioInput.addEventListener('change', (e) => {
            e.currentTarget.closest('.boolean-que-ans').classList.remove('active');
            e.currentTarget.closest('.boolean-que-ans').classList.add('answered');

            document.querySelectorAll('.treatment-tool-question .boolean-que-ans').forEach(allBoolQue => {
              if(allBoolQue.classList.contains('active')){
                allBoolQue.classList.remove('active');
              }
              if(allBoolQue.classList.contains('quiz-complete')){
                allBoolQue.classList.remove('quiz-complete');
              }
            }); 

            if(currentQueOpt != 'question-5') {
              e.currentTarget.closest('.boolean-que-ans').nextElementSibling.scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
              });
              e.currentTarget.closest('.boolean-que-ans').nextElementSibling.classList.add('active');
              e.currentTarget.closest('.boolean-que-ans').nextElementSibling.querySelectorAll('input[type="radio"]').forEach(radio => {
                radio.removeAttribute('disabled');
              });
            }
            else {
              e.currentTarget.closest('.boolean-que-ans').classList.add('quiz-complete');
              document.querySelector('.treatment-tool-boolean-que-ans .icon-arrow-next').classList.add('active');
              document.getElementById('generate-result').classList.remove('disabled');
            }
            if(this.progressBar != null){
              this.progressBar.style.width = progress + "%";
            }

            var boolQueVal = e.target.value;
            window.dataLayer.push(
            {
              'event': 'tot_question_answer',
              question_number: progressIndex,
              answer: boolQueVal
            });
            
          });
        });
      });

      // get result summurry + get answer object
      document.getElementById('generate-result').addEventListener('click', (event) => {
        if (event.target.classList.contains('disabled')){
          if(!document.getElementById('treatment-tool-landing-tile').classList.contains('hide')) {
            this.scrollToInitialTile();
          }
          else if(document.getElementById('unlock-question').classList.contains('disabled')) {
            this.scrollZoomToInitialQue();
          }
          else if(!document.getElementById('unlock-question').classList.contains('answered')) {
              document.getElementById("unlock-question").scrollIntoView({
                behavior: "smooth",
                block:  "center",
                inline: "center",
              });
              setTimeout(function(){
                document.querySelector(".treatment-tool-main .unlock-question").classList.add('pulse-effect');
              },300);
              setTimeout(function(){
                document.querySelector(".treatment-tool-main .unlock-question").classList.remove('pulse-effect');
              },1500);
          }
          else {
            if(document.getElementById('unlock-question').classList.contains('answered')){
              document.querySelector(".treatment-tool-boolean-que-ans .boolean-que-ans.active").scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
              });
            }
            else {
              this.scrollToInitialTile();
            }
          }
        }
        else {
          // get choosed vas score in answer object
          let firstQue = this.questions[0].question.replace('<br>','').replace('<br class="d-lg-block d-none">','');
          let firstCategory = this.questions[0].category;
          let vasScore = parseInt(document.querySelector('.treatment-tool-question input[type="range"]').value);
          this.answers[0].question = firstQue;
          this.answers[0].category = firstCategory;
          this.answers[0].vas_score = vasScore;

          // get selected triggers in answer object
          let secondQue = this.questions[1].question.replace('<br>','').replace('<br class="d-lg-block d-none">','');
          let secondCategory = this.questions[1].category;
          let secondQueOptions = this.answers[1].answer;
          this.answers[1].question = secondQue;
          this.answers[1].category = secondCategory;
          secondQueOptions.splice(0, secondQueOptions.length);
          let optionObj = {};
          document.querySelectorAll('.treatment-tool-question .symptoms-container input[type="checkbox"]').forEach(input => {
            if (input.checked == true) {
              optionObj = {
                  title: `${input.value}`,
                  selected: true,
              }
              secondQueOptions.push(optionObj);
            }
            else {
              optionObj = {
                  title: `${input.value}`,
                  selected: false,
              }
              secondQueOptions.push(optionObj);
            }
          });
          this.answers[1].answer = secondQueOptions;

          // get boolean selected answers in answer object
          let booleanQueCurrIndex = 1;
          document.querySelectorAll('.treatment-tool-question .boolean-que-ans').forEach(booleanQue => {
            booleanQueCurrIndex = booleanQueCurrIndex + 1;

            let booleanCurrQue = this.questions[booleanQueCurrIndex].question.replace('<br>','');
            let booleanCurrCategory = this.questions[booleanQueCurrIndex].category;
            let booleanCurrQueOptions = this.answers[booleanQueCurrIndex].answer;
            this.answers[booleanQueCurrIndex].question = booleanCurrQue;
            this.answers[booleanQueCurrIndex].category = booleanCurrCategory;
            booleanCurrQueOptions.splice(0, booleanCurrQueOptions.length);
            
            let optionObj = {};
            booleanQue.querySelectorAll('input[type="radio"]').forEach(input => {
              if (input.checked == true) {
              optionObj = {
                  title: `${input.value}`,
                  selected: true,
              }
              booleanCurrQueOptions.push(optionObj);
            }
            else {
              optionObj = {
                  title: `${input.value}`,
                  selected: false,
              }
              booleanCurrQueOptions.push(optionObj);
            }
            });
            this.answers[booleanQueCurrIndex].answer = booleanCurrQueOptions;
          });

          // console.log('this.answers: ');
          // console.log(this.answers);
          this.createAnsSummaryHTML();

          // window.dataLayer.push({
          //   'event': 'tot_completed'
          // });
        }
      });

      document.querySelectorAll('.treatment-tool-boolean-que-ans .boolean-que-ans>span').forEach(queNumbers => {
        queNumbers.addEventListener('click', async (event) => {
          if(!document.getElementById('unlock-question').classList.contains('disabled') && !document.getElementById('unlock-question').classList.contains('answered')) {
            document.getElementById("unlock-question").scrollIntoView({
              behavior: "smooth",
              block:  "center",
              inline: "center",
            });
            setTimeout(function(){
              document.querySelector(".treatment-tool-main .unlock-question").classList.add('pulse-effect');
            },300);
      
            setTimeout(function(){
              document.querySelector(".treatment-tool-main .unlock-question").classList.remove('pulse-effect');
            },1500);
          }
        });
      });

      this.indicatorPopupShowHide()

      window.addEventListener('popstate', (event) => {
          if (this.unsavedChanges) {
              this.closeQuizPopup.classList.remove('d-none');
              if(document.referrer != ''){
                this.clickedLink = document.referrer;
              }
          }
      });
      // this.closeQuizPopup.addEventListener('click', (event) => {
      //   if (!event.target.closest('.popup-content')) {
      //     this.closeQuizPopup.classList.add('d-none');
      //   }
      // });
      // Initial state to prevent direct back navigation
      history.pushState(null, '', location.href);

      document.querySelectorAll('.treatment-tool .site-header a').forEach(headerLink => {
        headerLink.classList.add('tot-link');
        headerLink.addEventListener('click', (event) => {
          if (this.unsavedChanges) {
            event.preventDefault();
            let linkHref = event.currentTarget.getAttribute("href");
            this.closeQuizPopup.classList.remove('d-none');
            this.clickedLink = linkHref;
            return false;
          }
        });
      });

      document.querySelector('.quiz-popup-overlay[data-close-quiz-popup] .no-btn').addEventListener('click', () => {
        this.closeQuizPopup.classList.add('d-none');
      });
      document.querySelector('.quiz-popup-overlay[data-close-quiz-popup] .yes-btn').addEventListener('click', () => {
        window.location.href = this.clickedLink;
      });

      // form submission
      this.signupForm.querySelector('button').addEventListener('click', async (event) => {
        event.preventDefault();
        let nameInput = this.signupForm.querySelector('input[name="first_name"]');
        let emailInput = this.signupForm.querySelector('input[name="email"]');
        const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        let verifiedEmail = emailInput.value.match(emailPattern);
        let verifiedName = nameInput.value.match(/^[A-Za-z ]+$/);
        let consentBox = this.signupForm.querySelector('input[data-consent-checkbox]');
        let concentBox2 = this.signupForm.querySelector('input[data-consent-checkbox2]');
        let inputs = [emailInput];
        let emailValue = emailInput.value;
        inputs.forEach(input =>{
            input.addEventListener('blur', () =>{
                if(input.classList.contains('required') && input.value != null) {
                    input.classList.remove('required');
                }
            })
        })
        /*if (this.getCookie('BUID_Cookie')) {
            this.answerStorage.forEach(obj => {
                window.dataLayer.push(obj);
            })
        }*/
        if(verifiedEmail == null) {
            emailInput.classList.add('required');
        }
        // if(verifiedName == null) {
        //     nameInput.classList.add('required');
        // }
        /*if (consentBox.checked && !concentBox2.checked) {
            window.dataLayer.push({
                event: 'web_cgr_report_form',
                status1: 'Yes',
                status2: 'No'
            });
        } else if (consentBox.checked && concentBox2.checked) {
            window.dataLayer.push({
                event: 'web_cgr_report_form',
                status1: 'Yes',
                status2: 'Yes'
            });
        }*/
        // if(!consentBox.checked) {
        //     let parent = consentBox.closest('.checkbox-label');
        //     let checkMark = parent.querySelector('.custom-checkmark');
        //     checkMark.classList.add('required');
        // }
        // if(verifiedEmail && consentBox.checked) {
        if(verifiedEmail) {
            let formData = new FormData(this.signupForm);
            formData.append(
                'existing_external_id',
                md5(emailValue)
            )
            const response = await fetch("https://datahub.klarify.me/api/webhook/create_braze_profile", {
                method: "POST",
                body: formData,
            });
            const res = await response.json();
            if (response.status == 200) {
                if(res.data.attributes[0].external_id != '') {
                    if (typeof braze !== 'undefined') {
                        //braze sdk is loaded and we can tun the changeUser function
                        braze.changeUser(this.responseText);
                    }
                    if (typeof appboy !== 'undefined') {
                        //braze legacy sdk(appboy) is loaded and we can tun the changeUser function
                        appboy.changeUser(this.responseText);
                    }
                    if (this.getCookie('BUID_Cookie') == '' || this.getCookie('BUID_Cookie') == undefined) {
                        this.setCookie('BUID_Cookie', res.data.attributes[0].external_id);
                    }
                    this.setCookie('TOTID_Cookie', res.data.attributes[0].external_id);
                    this.setCookie('TOT_email', emailValue);
                    this.TOTID_Cookie = res.data.attributes[0].external_id;
                    this.TOT_email = emailValue;

                    let thankyouText = '';
                    if(this.knownUser){
                        thankyouText = getTranslationUtility.getTranslation("Your child's report has been sent now. Thank you for doing the Allergy Treatment Review.");
                    }
                    else {
                        let newsletterSignup = document.querySelector('.braze-form-container.signup input[name="newsletter_signup"]');
                        if(newsletterSignup.checked) {
                            thankyouText = getTranslationUtility.getTranslation("You’ll shortly be getting a confirmation email. Please click on the link in the email so we know it’s really you. Then we’ll send the report.");
                            document.querySelector('.braze-form-container.result .result-message').classList.remove('d-none');
                            this.newsletterSignupVal = 'on';
                        }
                        else {
                            thankyouText = getTranslationUtility.getTranslation("Your child's report has been sent now. Thank you for doing the Allergy Treatment Review.");
                            this.newsletterSignupVal = 'off';
                        }
                    }
                    document.querySelector('.braze-form-container.result .description').innerHTML = thankyouText;

                    document.querySelector('.braze-form-container.result').classList.remove('d-none');
                    document.querySelector('.braze-form-container.result').classList.add('d-flex');
                    document.querySelector('.braze-form-container.signup').classList.add('d-none');
                    document.querySelector('.braze-form-container.signup').classList.remove('d-flex');

                    document.querySelectorAll('#braze-form-main input[type="checkbox"]').forEach(formCheckboxes => {
                        formCheckboxes.checked = false;
                    }); 
                    document.querySelectorAll('#braze-form-main input[type="text"], #braze-form-main input[type="email"]').forEach(formInputboxes => {
                        formInputboxes.value = '';
                    });

                    let bodyData = {
                        "response": this.answers,
                        "email": emailValue,
                        "external_id": this.TOTID_Cookie,
                        "language": this.signupForm.querySelector('input[name="language"]').value,
                    };
                    this.sendAnswer(bodyData);

                    window.dataLayer.push({
                      event: 'report_result_signup'
                    });
                }
            }
            this.unsavedChanges = false;
        }
    });

      // references script start
      const accordionButtons = document.querySelectorAll(
          '.references-ccordion .shogun-accordion-header .shogun-accordion-title'
      );

      if (accordionButtons.length === 0) {
        console.warn('No accordion buttons found with the specified selector');
        return;
      }

      accordionButtons.forEach((btn) => {
          console.log("All accordion buttons:", btn);
        btn.addEventListener('click', (event) => {
          console.log("Accordion button clicked:", event.target);
          const toggleContent = event.target.closest('.shogun-accordion');
          console.log("toggleContent", toggleContent) // Note: Typo in original ('accordion' vs 'accordion')
          if (!toggleContent) {
            console.error('Could not find parent accordion element');
            return;
          }

          const toggleBody = toggleContent.querySelector('.shogun-accordion-body');
          if (!toggleBody) {
            console.error('Could not find accordion body element');
            return;
          }

          const isOpen = toggleContent.classList.contains('shogun-accordion-active');
          console.log("isOpen", isOpen);
          toggleContent.classList.toggle('shogun-accordion-active', !isOpen);
          toggleBody.classList.toggle('shogun-accordion-active', !isOpen);
        });
      });

      document.querySelectorAll('.references-ccordion .shogun-accordion-title').forEach((accordionEl) => {
        console.log('Accordion element:', accordionEl);
        accordionEl.addEventListener('click', (titleEl) => {
          let bodyAccodian = titleEl.target.parentNode.parentNode.parentNode.querySelector('.shogun-accordion-body');
          let heightActiveAccordion = titleEl.target.parentNode.parentNode.parentNode.querySelector(
            '.shogun-accordion-body .shg-c .shg-theme-text-content'
          ).offsetHeight;
          console.log(bodyAccodian);
          if (bodyAccodian.classList.contains('shogun-accordion-active'))
            bodyAccodian.style.height = heightActiveAccordion + 'px';
          else bodyAccodian.style.height = '0px';
        });
      });
      // references script end
    },

    setQuestionHTML() {
      let questionsHTML = ``;
      let indicatorHTML = ``;
      let triggersHTML = ``;
      let booleanQueHTML = ``;
      var booleanQueIndex = 0;
      this.questions.forEach((question, questionIndex) => {
        if(question.category == 'vas') {
          //html for indicator
          indicatorHTML = `
              <div class="initial-question-heading">
                  ${question.question}
              </div>
              <div class="scale-container mx-auto">
                  <div class="position-relative">
                      <span class="disable-slider"></span>
                      <input type="range" min="0" max="10" value="0" class="slider" id="impact-rate" disabled>
                      <div class="number-labels">
                      <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                      <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                      </div>
                  </div>
                  <div class="labels">
                      <span class="slider-not-affected indicator-text">${getTranslationUtility.getTranslation('NOT AFFECTED')}</span>
                      <span class="slider-very-affected indicator-text">${getTranslationUtility.getTranslation('VERY AFFECTED')}</span>
                  </div>
                  <div class="character">
                      <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DT_blue_blob_test.svg" alt="Slider Character">
                  </div>
                  <div class="indicator-popup-text-container">${getTranslationUtility.getTranslation('Understand the scale')}</div>
              </div>
          `;
          // indicatorHTML += indicatorHTML;
        }
        else if (question.category == 'triggers') {
          //html for triggers
          let triggersOptions = ``;
          question.multipleOptions.forEach((option,optionIndex) => {
            if(optionIndex < 5) {
              let triggersOption = `
                <div class="symptoms-option">
                  <label>
                    <input type="checkbox" name="symptom-${questionIndex}" value="${option.title}" disabled>
                    <span>${option.title}</span>
                  </label>
                </div>
              `;
              triggersOptions += triggersOption;
            }
          });

          let triggersImg = `
            <div class="symptoms-img">
                <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_ToT_-_Q_flow_-_Trigger_Blobs.png?v=1747909268" alt="Symptom Character">
            </div>`;

          triggersOptions += triggersImg;

          question.multipleOptions.forEach((option,optionIndex) => {
            if(optionIndex == 5) {
              let optionTitle = option.title;
              var onlyText = document.createElement("div");
              onlyText.innerHTML = optionTitle;

              let triggersOption = `
                <div class="symptoms-option">
                  <label>
                    <input type="checkbox" name="symptom-${questionIndex}" value="${onlyText.innerText}" data-none-option="true" disabled>
                    <span>${option.title}</span>
                  </label>
                </div>
              `;
              triggersOptions += triggersOption;
            }
          });

          triggersHTML = `
            <div class="initial-question-heading">
                ${question.question}
            </div>
            <div class="symptoms-option-container col-12 col-md-12">
                ${triggersOptions}
            </div>
          `;
          // triggersHTML += triggersHTML;
        }
        else {
          //html for boolean questions
          booleanQueIndex = booleanQueIndex + 1;
          let booleanOptions = ``;
          question.answerOptions.forEach((option) => {
              let booleanOption = `
                  <label class="checkbox-item">
                    <input type="radio" name="boolean-que-${booleanQueIndex}" value="${option.title}" disabled>
                    <span class="${option.icon}" data-answer="${option.title}"></span>
                  </label>
              `;
              booleanOptions += booleanOption;
          });
          booleanQueHTML += `
            <div class="boolean-que-ans" data-options="question-${booleanQueIndex}" id="question_${booleanQueIndex}">
              <hr>
              <img class="active-blob" src="${this.imageQueCharacter}" alt="blog-image">
              <span>${booleanQueIndex}</span>
              <div class="que-ans-heading">
                  ${question.question}
              </div>
              <div class="answer-container">
                  ${booleanOptions}
              </div>
            </div>
          `;
        }
      });

      questionsHTML = `
        <div class="container">
                <div class="justify-content-evenly justify-content-xl-center treatment-tool-initial-que-ans">
                    <h2 class="col-12">
                        ${getTranslationUtility.getTranslation('Let’s create your child’s <br class="d-lg-block d-none"> allergy profile')}
                    </h2>
                    <div class="col-12 col-lg-6">
                        <div class="indicator-container">
                            ${indicatorHTML}
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="symptoms-container">
                            ${triggersHTML}
                        </div>
                    </div>
                </div>
                <div class="justify-content-evenly row unlock-question-button">
                    <div class="col-12">
                        <button id="unlock-question" class="unlock-question tot-quiz-btn disabled">${getTranslationUtility.getTranslation('unlock your <br> child’s allergy journey')}</button>
                    </div>
                </div>
                <div class="justify-content-evenly row treatment-tool-boolean-que-ans">
                    <div class="col-12 col-md-9 col-lg-8">
                      ${booleanQueHTML}
                      <span class="fw-bolder icon-arrow-next"></span>
                    </div>
                </div>
                <div class="justify-content-evenly row">
                    <div class="col-12">
                        <button id="generate-result" class="generate-result tot-quiz-btn disabled">${getTranslationUtility.getTranslation('Generate my results')}</button>
                    </div>
                </div>
            </div>
      `;
      document.querySelector('.treatment-tool-question').innerHTML = questionsHTML; 

      // set progress bar 
      const progressBarContainer = document.createElement('div');
      const progressBar = document.createElement('div');
      progressBarContainer.id = 'progress-bar-container';
      progressBar.id = 'progress-bar';
      progressBarContainer.appendChild(progressBar);
      const pageHeader = document.querySelector('.site-header');
      if (pageHeader) {
        pageHeader.appendChild(progressBarContainer);
        this.progressBar = document.querySelector('#progress-bar')
      }
    },

    createAnsSummaryHTML() { 
      let initialAnswersHTML = ``;
      let indicatorAnsHTML = ``;
      let whatNextHTML = ``;
      let pollenTrigger = ``, dustTrigger = ``, animalTrigger = ``, moldTrigger = ``, otherUnknowTrigger = ``;
      var booleanAnsIndex = 0;
      let ans2CarouselHTML = ``;
      let ans3CarouselHTML = ``;
      let ans4ContentHTML = ``;
      let ans5ContentHTML = ``;

      whatNextHTML = `
        <div class="whats-next-container">
            <img class="col-md-6" src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_What_s_next_Blobs.png?v=1746536797" alt="DTP_-_Result_-_blobs_group_tot_mold.png" loading="lazy">
            <h3 class="whats-next-heading">${getTranslationUtility.getTranslation('What’s next?')}</h3>
            <ul>
              <li>${getTranslationUtility.getTranslation('Check out the insights and tips below')}</li>
              <li>${getTranslationUtility.getTranslation('Send them to yourself as a handy eBooklet')}</li>
              <li>${getTranslationUtility.getTranslation('And find the symptom diary and kids’ allergy medication guide inside')}</li>
            </ul>
        </div>
      `;

      this.answers.forEach((answer, answerIndex) => {
        if(answer.category == 'vas') {
          let imageCharacter = '';
          let imageAnsCharacter = '';
          if (answer.vas_score == 0) {
              imageCharacter = this.indicatorImages[0];
              imageAnsCharacter = this.indicatorAnsImages[0];
              this.highestVASColor = '#009DC1';
              this.reportHeading = getTranslationUtility.getTranslation("Satisfactory, for now");
              this.reportText = getTranslationUtility.getTranslation("You’ve rated your child as unaffected by symptoms while on current treatment. But if you're worried, it's a good idea to discuss your child’s allergy with a doctor.");
          }
          if (answer.vas_score == 1) {
              imageCharacter = this.indicatorImages[1];
              imageAnsCharacter = this.indicatorAnsImages[1];
              this.highestVASColor = '#8DCEC8';
              this.reportHeading = getTranslationUtility.getTranslation("Promising but not perfect");
              this.reportText = getTranslationUtility.getTranslation("You’ve rated your child as mildly affected by symptoms while on current treatment. But if you're worried, it's a good idea to discuss your child’s allergy with a doctor.");
          }
          if (answer.vas_score < 5 && answer.vas_score > 1) {
              imageCharacter = this.indicatorImages[2];
              imageAnsCharacter = this.indicatorAnsImages[2];
              this.highestVASColor = '#F1AB34';
              this.reportHeading = getTranslationUtility.getTranslation("Room for improvement");
              this.reportText = getTranslationUtility.getTranslation("You’ve rated your child as somewhat affected by symptoms while on current treatment. Keeping a symptom diary could help your doctor find the best allergy plan for your child.");
          }
          if (answer.vas_score > 4) {
              imageCharacter = this.indicatorImages[3];
              imageAnsCharacter = this.indicatorAnsImages[3];
              this.highestVASColor = '#FF3317';
              this.reportHeading = getTranslationUtility.getTranslation("May struggle without better support");
              this.reportText = getTranslationUtility.getTranslation("You’ve rated your child as significantly affected by symptoms while on current treatment. Keeping a symptom diary could help your doctor find the best allergy plan for your child.");
          }
          this.imageCharacter = imageCharacter;
          this.imageAnsCharacter = imageAnsCharacter;

          indicatorAnsHTML = `
            <div class="indicator-container text-center">
              <div class="scale-container mx-auto d-block d-lg-none">
                  <div class="character">
                      <img src="${this.imageCharacter}" alt="Slider Character">
                  </div>
                  <div class="position-relative">
                      <input type="range" min="0" max="10" value="${answer.vas_score}" class="slider" id="impact-rate-result" disabled>
                      <div class="number-labels">
                          <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                          <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                      </div>
                      <div class="indicator-popup-text-container">${getTranslationUtility.getTranslation('Understand the scale')}</div>
                  </div>
              </div>
              <h3 class="indicator-heading" style="color: ${this.highestVASColor};">${this.reportHeading}</h3>
              <p class="indicator-text">${this.reportText}</p>
              <div class="scale-container mx-auto d-none d-lg-block">
                  <div class="character">
                      <img src="${this.imageCharacter}" alt="Slider Character">
                  </div>
                  <div class="position-relative">
                      <input type="range" min="0" max="10" value="${answer.vas_score}" class="slider" id="impact-rate-result" disabled>
                      <div class="number-labels">
                          <span>0</span><span>1</span><span>2</span><span>3</span><span>4</span><span>5</span>
                          <span>6</span><span>7</span><span>8</span><span>9</span><span>10</span>
                      </div>
                      <div class="indicator-popup-text-container">${getTranslationUtility.getTranslation('Understand the scale')}</div>
                  </div>
              </div>
            </div>
          `;
        }
        else if (answer.category == 'triggers') {
          answer.answer.forEach(option => {
                let dkOptionTitle = getTranslationUtility.getTranslation('Don’t know');
                var dkOnlyText = document.createElement("div");
                dkOnlyText.innerHTML = dkOptionTitle;
                var dkOnlyTextVal = dkOnlyText.innerText;

                if (option.title == getTranslationUtility.getTranslation('Pollen') && option.selected == true) {
                    pollenTrigger = 'active';
                    localStorage.setItem('pageviewTree', 'true');
                }
                else if (option.title == getTranslationUtility.getTranslation('Dust mites') && option.selected == true) {
                    dustTrigger = 'active';
                    localStorage.setItem('pageviewMite', 'true');
                }
                else if (option.title == getTranslationUtility.getTranslation('Animals') && option.selected == true) {
                    animalTrigger = 'active';
                    localStorage.setItem('pageviewVenom', 'true');
                }
                else if (option.title == getTranslationUtility.getTranslation('Mold') && option.selected == true) {
                    moldTrigger = 'active';
                }
                else if ((option.title == getTranslationUtility.getTranslation('Other') && option.selected == true) || (option.title == dkOnlyTextVal && option.selected == true)) {
                    otherUnknowTrigger = 'active';
                }
            });

            window.dataLayer.push({
                event:'tot_completed',
                // persona: 'caregiver',
                // cj_stage: 'ready_for_action',
                // allergy_type_trees: localStorage.getItem('pageviewTree') == 'true' ? 'yes' : 'no',
                // allergy_type_grasses: localStorage.getItem('pageviewGrass') == 'true' ? 'yes' : 'no',
                // allergy_type_weeds: localStorage.getItem('pageviewWeed') == 'true' ? 'yes' : 'no',
                // allergy_type_mites: localStorage.getItem('pageviewMite') == 'true' ? 'yes' : 'no',
                // allergy_type_venom: localStorage.getItem('pageviewVenom') == 'true' ? 'yes' : 'no',
            });

        }
        else {
          booleanAnsIndex = booleanAnsIndex + 1;
          let booleanCurrAns = false;
          answer.answer.forEach(option => {
            // console.log('option: ');
            // console.log(option.title);
            // console.log(option.selected);
            if (option.title == 'yes' && option.selected == true) {
              booleanCurrAns = true;
            }
          });
          if(booleanCurrAns) {
            this.booleanAns.push(true);
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] .answer-content .que-ans-heading`).innerHTML = this.answersContent[booleanAnsIndex].yesHeading;
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] .answer-content p`).innerHTML = this.answersContent[booleanAnsIndex].yesText;
          }
          else {
            this.booleanAns.push(false);
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] .answer-content .que-ans-heading`).innerHTML = this.answersContent[booleanAnsIndex].noHeading;
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] .answer-content p`).innerHTML = this.answersContent[booleanAnsIndex].noText;
          
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] img.active-blob`).setAttribute('src', this.imageAnsCharacter);
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"]`).classList.add('active'); 
          }

          document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] + .answer-accordion .global-acoordion-title`).innerHTML = this.answersContent[booleanAnsIndex].accordionHeading;

          if(booleanAnsIndex == 2) {
            ans2CarouselHTML = `
              <div class="testing-types d-lg-flex swiper-slide">
                <div class="col-12 col-lg-4 p-0">
                    <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_blobs_group_tot_skin-prick_test.png?v=1746791519" alt="DTP_-_Result_-_blobs_group_tot_skin-prick_test.png" loading="lazy" class="col-8 col-lg-10 p-0">
                </div>
                <div class="col-12 col-lg-8">
                    <h5>${getTranslationUtility.getTranslation('Skin prick test')}</h5>
                    <p>${getTranslationUtility.getTranslation('Diluted allergens are dropped onto the child’s skin, which is gently pricked. A red bump like a mosquito bite is a reaction.')}</p>
                </div>
            </div>
            <div class="testing-types d-lg-flex swiper-slide">
                <div class="col-12 col-lg-4 p-0">
                    <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_blobs_group_tot_blood-test.png?v=1746792403" alt="DTP_-_Result_-_blobs_group_tot_blood-test.png" loading="lazy" class="col-8 col-lg-10 p-0">
                </div>
                <div class="col-12 col-lg-8">
                    <h5>${getTranslationUtility.getTranslation('Allergy blood test')}</h5>
                    <p>${getTranslationUtility.getTranslation('Blood tests check if children have IgE antibodies against different allergy triggers.')}</p>
                </div>
            </div>
            `;
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] + .answer-accordion .testing-types-wrapper`).innerHTML = ans2CarouselHTML;

            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] + .answer-accordion .testing-types-description p`).innerHTML = this.answersContent[booleanAnsIndex].bottomDescription;
            
          }
          if(booleanAnsIndex == 3) {
            let pollenAllergy = ``;
            if(pollenTrigger == 'active' || otherUnknowTrigger == 'active') {
              pollenAllergy = `
                <div class="testing-types pollen-allergy swiper-slide">
                  <div class="align-items-center d-md-flex">
                      <div class="col-12 col-md-3 p-0">
                        <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_blobs_group_tot_grass-cropped.png?v=1746621601" alt="DTP_-_Result_-_blobs_group_tot_grass.png" loading="lazy" class="col-8 col-md-12 p-0">
                      </div>
                      <div class="col-12 col-md-10">
                        <h5>${getTranslationUtility.getTranslation('Practical tips for<br> pollen allergy')}</h5>
                      </div>
                  </div>
                  <div class="col-12">
                    <ol>
                      <li>${getTranslationUtility.getTranslation('Check the pollen forecast daily.')}</li>
                      <li>${getTranslationUtility.getTranslation('Get your child to wear a hat and sunglasses to shield their eyes from pollen.')}</li>
                      <li>${getTranslationUtility.getTranslation('Keep windows and doors closed unless the pollen count is low.')}</li>
                      <li>${getTranslationUtility.getTranslation('Get kids to change out of daytime clothes in the bathroom and wash their hair.')}</li>
                      <li>${getTranslationUtility.getTranslation('Use a tumble dryer or hang laundry inside not outdoors.')}</li>
                    </ol>
                  </div>
                </div>
              `;
            }
            let dustAllergy = ``;
            if(dustTrigger == 'active' || otherUnknowTrigger == 'active') {
              dustAllergy = `
                <div class="testing-types mite-allergy swiper-slide">
                  <div class="align-items-center d-md-flex">
                    <div class="col-12 col-md-3 p-0">
                      <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_blobs_group_tot_dust_mites-cropped.png?v=1747909089" alt="DTP_-_Result_-_blobs_group_tot_dust_mites.png" loading="lazy" class="col-8 col-md-12 p-0">
                    </div>
                    <div class="col-12 col-md-10">
                      <h5>${getTranslationUtility.getTranslation('Practical tips for<br> dust mite allergy')}</h5>
                    </div>
                  </div>
                  <div class="col-12">
                    <ol>
                      <li>${getTranslationUtility.getTranslation('Keep humidity below 50% in your home.')}</li>
                      <li>${getTranslationUtility.getTranslation('Put mite-proof covers on your child’s mattress and bedding.')}</li>
                      <li>${getTranslationUtility.getTranslation('Hot-wash bed linen weekly.')}</li>
                      <li>${getTranslationUtility.getTranslation('Be aware of dust traps: Carpet, curtains, pet beds and laundry baskets.')}</li>
                      <li>${getTranslationUtility.getTranslation('Pop stuffed toys regularly into the freezer for 48 hours.')}</li>
                      <li>${getTranslationUtility.getTranslation('Clean with a damp cloth and a vacuum with a HEPA filter.')}</li>
                    </ol>
                  </div>
                </div>
              `;
            }
            let animalAllergy = ``;
            if(animalTrigger == 'active' || otherUnknowTrigger == 'active') {
              animalAllergy = `
                <div class="testing-types animals-allergy swiper-slide">
                  <div class="align-items-center d-md-flex">
                    <div class="col-12 col-md-3 p-0">
                      <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_blobs_group_tot_pets-cropped.png?v=1747909089" alt="DTP_-_Result_-_blobs_group_tot_pets.png" loading="lazy" class="col-8 col-md-12 p-0">
                    </div>
                    <div class="col-12 col-md-10">
                      <h5>${getTranslationUtility.getTranslation('Practical tips for<br> allergies to animals')}</h5>
                    </div>
                  </div>
                  <div class="col-12">
                    <ol>
                      <li>${getTranslationUtility.getTranslation('Make your child’s bedroom a pet-free zone.')}</li>
                      <li>${getTranslationUtility.getTranslation('Teach them not to let animals lick them and to wash hands after contact.')}</li>
                      <li>${getTranslationUtility.getTranslation('Make changing clothes the routine anytime they’ve been with an animal.')}</li>
                      <li>${getTranslationUtility.getTranslation('Use a vacuum fitted with a HEPA filter.')}</li>
                      <li>${getTranslationUtility.getTranslation('Wash pets and their beds regularly.')}</li>
                    </ol>
                  </div>
                </div>
              `;
            }
            let moldAllergy = ``;
            if(moldTrigger == 'active' || otherUnknowTrigger == 'active') {
              moldAllergy = `
                <div class="testing-types mold-allergy swiper-slide">
                  <div class="align-items-center d-md-flex">
                    <div class="col-12 col-md-3 p-0">
                      <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_blobs_group_tot_mold-cropped.png?v=1747909089" alt="DTP_-_Result_-_blobs_group_tot_mold.png" loading="lazy" class="col-8 col-md-12 p-0">
                    </div>
                    <div class="col-12 col-md-10">
                      <h5>${getTranslationUtility.getTranslation('Practical tips for<br> mold allergy')}</h5>
                    </div>
                  </div>
                  <div class="col-12">
                    <ol>
                      <li>${getTranslationUtility.getTranslation('Discourage kids from playing in damp autumn leaves.')}</li>
                      <li>${getTranslationUtility.getTranslation('Leave coats and outdoor shoes by the door.')}</li>
                      <li>${getTranslationUtility.getTranslation('Keep humidity below 50% at home.')}</li>
                      <li>${getTranslationUtility.getTranslation('Ventilate well, especially the kitchen and bathroom.')}</li>
                      <li>${getTranslationUtility.getTranslation('Clean mold hot spots: rubber seals; refrigerator drip-pans; window frames; and the bathroom.')}</li>
                    </ol>
                  </div>
                </div>
              `;
            }
            ans3CarouselHTML = `
                ${pollenAllergy}
                ${dustAllergy}
                ${animalAllergy}
                ${moldAllergy}
            `;
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] + .answer-accordion .testing-types-wrapper`).innerHTML = ans3CarouselHTML;

            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] + .answer-accordion .testing-types-description p`).innerHTML = this.answersContent[booleanAnsIndex].bottomDescription;
          }
          if(booleanAnsIndex == 4) {
            ans4ContentHTML = `
              <div class="testing-types">
                <div class="align-items-center d-flex">
                  <div class="col-4 col-md-3 p-0">
                      <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_blobs_group_tot_Short_term.png?v=1746795820" alt="DTP_-_Result_-_blobs_group_tot_Short_term.png" loading="lazy" class="col-12 col-lg-10 p-0">
                  </div>
                  <div class="col-8 col-md-9">
                      <h5>${getTranslationUtility.getTranslation('Antihistamines, <br>corticosteroids, <br>decongestants and so on')}</h5>
                  </div>
                </div>
                <div class="col-12">
                  <h6>${getTranslationUtility.getTranslation('for short-term relief')}</h6>
                  <ul>
                      <li>${getTranslationUtility.getTranslation('Short-term relief can block or calm symptoms temporarily.')}</li>
                      <li>${getTranslationUtility.getTranslation('Best taken before the reaction starts; your child may also need medication any time they’re exposed to their trigger.')}</li>
                      <li>${getTranslationUtility.getTranslation('Topical forms include nasal sprays, eye drops, creams, lotions, gels and inhalers.')}</li>
                      <li>${getTranslationUtility.getTranslation('Tablets, capsules, liquids or syrups are usually for stronger or multiple symptoms.')}</li>
                      <li>${getTranslationUtility.getTranslation('If it isn’t working, your doctor can suggest a different antihistamine or corticosteroid. There are different kinds and it might be worth checking another one out.')}</li>
                  </ul>
                </div>
            </div>
            `;
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] + .answer-accordion .testing-types-wrapper`).innerHTML = ans4ContentHTML;
          }
          if(booleanAnsIndex == 5) {
            ans5ContentHTML = `
              <div class="testing-types">
                <div class="align-items-center d-flex">
                  <div class="col-4 col-md-3 p-0">
                      <img src="https://cdn.shopify.com/s/files/1/0605/5156/1273/files/DTP_-_Result_-_blobs_group_tot_long_time.png?v=1747660901" alt="DTP_-_Result_-_blobs_group_tot_Short_term.png" loading="lazy" class="col-12 col-lg-10 p-0">
                  </div>
                  <div class="col-8 col-md-9">
                      <h5>${getTranslationUtility.getTranslation('Allergy <br>immunotherapy')}</h5>
                  </div>
                </div>
                <div class="col-12">
                  <h6>${getTranslationUtility.getTranslation('for long-term relief')}</h6>
                  <ul>
                      <li>${getTranslationUtility.getTranslation('This treatment tackles the root cause of a child’s allergy.')}</li>
                      <li>${getTranslationUtility.getTranslation('Regular controlled doses of a trigger like pollen or dust mites help build a natural tolerance.')}</li>
                      <li>${getTranslationUtility.getTranslation('Allergy immunotherapy comes as tablets or shots depending on a child’s age and allergy.')}</li>
                      <li>${getTranslationUtility.getTranslation('The goal is to reduce symptoms and the need for regular allergy meds during and after treatment.')}</li>
                  </ul>
                </div>
            </div>
            `;
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] + .answer-accordion .testing-types-wrapper`).innerHTML = ans5ContentHTML;
          }

          if(booleanAnsIndex != 1) {
            document.querySelector(`.treatment-tool-result .boolean-que-ans[data-options="answer-${booleanAnsIndex}"] + .answer-accordion .get-parent-kit`).innerHTML = `<span class="btn-text">${getTranslationUtility.getTranslation('Get the parents’ allergy kit')}</span><span class="icon-Group-7501-1"></span>`;
          }
        }
      });
      initialAnswersHTML = `
        <div class="col-12 col-lg-5">
          ${indicatorAnsHTML}
        </div>
        <div class="col-12 col-lg-5">
          ${whatNextHTML}
        </div>
        <div class="col-12 text-center">
            <button id="get-kit" class="get-kit get-parent-kit tot-quiz-btn"><span class="btn-text">${getTranslationUtility.getTranslation('Get the parents’ allergy kit')}</span><span class="icon-Group-7501-1"></span></button>
        </div>
      `;
      document.querySelector('.treatment-tool-result .treatment-tool-initial-que-ans').innerHTML = initialAnswersHTML;

      document.querySelector('.treatment-tool-result').classList.remove('d-none');
      document.querySelector('.treatment-tool-question').classList.add('d-none');
      document.querySelector('.treatment-tool .references-ccordion').classList.add('d-block');
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' 
      });

      document.querySelector('.treatment-tool .site-header').classList.add('hide-progressbar');

      this.getParentKit();
      this.initSliders();
      this.toggelAccordions();
      this.indicatorPopupShowHide();
    },

    initSliders() {
      new Swiper('.testing-types-carousel.answer-2 .swiper-wrapper-div', {
        slidesPerView: 1.3,
        spaceBetween: 15,
        centeredSlides: false,
        pagination: {
          el: '.testing-types-carousel.answer-2 .swiper-pagination',
          type: 'bullets',
          clickable: true,
        },
        navigation: {
          nextEl: '.testing-types-carousel.answer-2 .swiper-button-next',
          prevEl: '.testing-types-carousel.answer-2 .swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 2,
          }
        }
      });

      if(document.querySelectorAll('.testing-types-carousel.answer-3 .testing-types-wrapper .testing-types').length > 1) {
        new Swiper('.testing-types-carousel.answer-3 .swiper-wrapper-div', {
          slidesPerView: 1.3,
          spaceBetween: 15,
          centeredSlides: false,
          pagination: {
            el: '.testing-types-carousel.answer-3 .swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          navigation: {
            nextEl: '.testing-types-carousel.answer-3 .swiper-button-next',
            prevEl: '.testing-types-carousel.answer-3 .swiper-button-prev',
          },
          breakpoints: {
            768: {
              slidesPerView: 1,
              spaceBetween: 2,
            }
          }
        });
      }
      else {
        document.querySelector('.testing-types-carousel.answer-3').classList.add('slider-single-child');
      }
    },

    getParentKit() {
      document.querySelectorAll('.treatment-tool-result .get-parent-kit').forEach(getKitBtn => {
        getKitBtn.addEventListener('click' , (event) => {
          let headerHeight = document.querySelector('.site-header').offsetHeight;
          document.getElementById("braze-form-main").setAttribute('style', `scroll-margin-top:${parseInt(headerHeight)+40}px;`);
          document.getElementById("braze-form-main").scrollIntoView();

          window.dataLayer.push({
            'event': 'tot_cta_click_to_get_results'
          });
        });
      });
    },

    toggelAccordions() {
      setTimeout(function() {
        document.querySelectorAll('.treatment-tool-result .global-acoordion-header').forEach( btn => {
          btn.addEventListener('click' , (event) => {
            let toggleContent = event.target.closest('.global-acoordion');
            let toggleBody = toggleContent.querySelector('.global-acoordion-body');
            let isOpen = toggleContent.classList.contains('global-acoordion-active');
            if(isOpen){
              toggleContent.classList.remove('global-acoordion-active');
              toggleBody.classList.remove('global-acoordion-active');
            }
            else{
              toggleContent.classList.add('global-acoordion-active');
              toggleBody.classList.add('global-acoordion-active');
            }
          });
        });
        document.querySelectorAll('.treatment-tool-result .global-acoordion-header').forEach((accordionEl)=>{
          accordionEl.addEventListener('click', (titleEl)=>{
            let heightActiveAccordion = 0;
            let bodyAccodian = titleEl.target.parentNode.parentNode.querySelector('.global-acoordion-body');
            if(titleEl.target.classList.contains('global-acoordion-header')) {
              heightActiveAccordion = titleEl.target.parentNode.parentNode.querySelector('.global-acoordion-body .accordion-body-wrapper').offsetHeight;
              bodyAccodian = titleEl.target.parentNode.parentNode.querySelector('.global-acoordion-body');
            }
            else {
              heightActiveAccordion = titleEl.target.parentNode.parentNode.parentNode.querySelector('.global-acoordion-body .accordion-body-wrapper').offsetHeight;
              bodyAccodian = titleEl.target.parentNode.parentNode.parentNode.querySelector('.global-acoordion-body');
            }
            if (bodyAccodian.classList.contains('global-acoordion-active'))  bodyAccodian.style.height =  heightActiveAccordion+'px';
            else bodyAccodian.style.height = '0px';
          });
        });

        document.querySelectorAll('.treatment-tool-result .treatment-tool-boolean-que-ans .boolean-que-ans.active').forEach( boolanNoAns => {
          boolanNoAns.nextElementSibling.querySelector('.global-acoordion-header').click();
        });
      },1500);
    },

    indicatorPopupShowHide() {
      document.querySelectorAll('.scale-container .indicator-popup-text-container').forEach(indicatorpopupText => {
      indicatorpopupText.addEventListener('click', () => {
          this.indicatorPopUp.classList.remove('d-none');
        });
      });
      this.indicatorPopUp.querySelector('.navigation-icon').addEventListener('click', () => {
          this.indicatorPopUp.classList.add('d-none');
      });
      this.indicatorPopUp.addEventListener('click', (event) => {
        if (!event.target.closest('.popup-content-wrapper')) {
          this.indicatorPopUp.classList.add('d-none');
        }
      });
    },

    scrollToInitialTile() {
      let headerHeight = document.querySelector('.site-header').offsetHeight;
      var scrollSelector = 'treatment-tool-landing-tile';
      if(window.innerWidth < 768) {
        scrollSelector = 'consent_checkbox';
      }
      document.getElementById(scrollSelector).setAttribute('style', `scroll-margin-top:${parseInt(headerHeight)+40}px;`);
      
      if(!document.querySelector('input[name="user_consent"]').checked && !document.querySelector('input[name="person_authentication"]').checked) {
        document.getElementById(scrollSelector).scrollIntoView();

        document.querySelector('.treatment-tool-landing-tile .consent_checkbox .custom-checkmark').classList.add('required');
        document.querySelector('.treatment-tool-landing-tile .consent_checkbox').classList.add('bounce-effect');
        document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext .custom-checkmark').classList.add('required');
        document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext').classList.add('bounce-effect');
        document.querySelector('.treatment-tool-landing-tile .required-field').classList.add('bounce-effect');
        setTimeout(function() {
          document.querySelector('.treatment-tool-landing-tile .consent_checkbox .custom-checkmark').classList.remove('required');
          document.querySelector('.treatment-tool-landing-tile .consent_checkbox').classList.remove('bounce-effect');
          document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext .custom-checkmark').classList.remove('required');
          document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext').classList.remove('bounce-effect');
          document.querySelector('.treatment-tool-landing-tile .required-field').classList.remove('bounce-effect');
        },2500);
      }
      else if(!document.querySelector('input[name="user_consent"]').checked) { 
        document.getElementById(scrollSelector).scrollIntoView();

        document.querySelector('.treatment-tool-landing-tile .consent_checkbox .custom-checkmark').classList.add('required');
        document.querySelector('.treatment-tool-landing-tile .consent_checkbox').classList.add('bounce-effect');
        document.querySelector('.treatment-tool-landing-tile .required-field').classList.add('bounce-effect');
        setTimeout(function() {
          document.querySelector('.treatment-tool-landing-tile .consent_checkbox .custom-checkmark').classList.remove('required');
          document.querySelector('.treatment-tool-landing-tile .consent_checkbox').classList.remove('bounce-effect');
          document.querySelector('.treatment-tool-landing-tile .required-field').classList.remove('bounce-effect');
        },2500);
      }
      else if(!document.querySelector('input[name="person_authentication"]').checked) { 
        document.getElementById(scrollSelector).scrollIntoView();

        document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext .custom-checkmark').classList.add('required');
        document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext').classList.add('bounce-effect');
        document.querySelector('.treatment-tool-landing-tile .required-field').classList.add('bounce-effect');
        setTimeout(function() {
          document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext .custom-checkmark').classList.remove('required');
          document.querySelector('.treatment-tool-landing-tile .consent_checkbox_ext').classList.remove('bounce-effect');
          document.querySelector('.treatment-tool-landing-tile .required-field').classList.remove('bounce-effect');
        },2500);
      }
      else if(!document.getElementById('treatment-tool-landing-tile').classList.contains('hide')) {
        scrollSelector = 'consent_checkbox';
        if(window.innerWidth < 768) {
          scrollSelector = 'start-quiz';
        }
        document.getElementById(scrollSelector).setAttribute('style', `scroll-margin-top:${parseInt(headerHeight)+80}px;`);
        document.getElementById(scrollSelector).scrollIntoView();
        
        setTimeout(function(){
          document.querySelector(".treatment-tool-landing-tile .start-quiz").classList.add('pulse-effect');
        },500);
        setTimeout(function(){
          document.querySelector(".treatment-tool-landing-tile .start-quiz").classList.remove('pulse-effect');
        },3500);
      }
    },

    scrollZoomToInitialQue() {
      let headerHeight = document.querySelector('.site-header').offsetHeight;
      document.querySelector(".treatment-tool-question .treatment-tool-initial-que-ans").setAttribute('style', `scroll-margin-top:${parseInt(headerHeight)+40}px;`);
      document.querySelector(".treatment-tool-question .treatment-tool-initial-que-ans").scrollIntoView();
      
      setTimeout(function(){
        document.querySelector(".treatment-tool-question .treatment-tool-initial-que-ans").classList.add('zoom-effect');
        document.querySelector(".treatment-tool-main .unlock-question").classList.add('zoom-effect');
      },500);

      setTimeout(function(){
        document.querySelector(".treatment-tool-question .treatment-tool-initial-que-ans").classList.remove('zoom-effect');
        document.querySelector(".treatment-tool-main .unlock-question").classList.remove('zoom-effect');
      },1500);
    },

    checkLandingTile() {
      if(document.getElementById("treatment-tool-landing-tile").classList.contains('hide') && !document.getElementById("treatment-tool-landing-tile").classList.contains('d-none')){
        document.getElementById("treatment-tool-landing-tile").classList.add('d-none');
        // window.scrollTo({
        //   top: 0,
        //   left: 0,
        //   behavior: 'instant' 
        // });
        let headerHeight = document.querySelector('.site-header').offsetHeight;
        document.querySelector(".treatment-tool-question .treatment-tool-initial-que-ans").setAttribute('style', `scroll-margin-top:${parseInt(headerHeight)+40}px;`);
        document.querySelector(".treatment-tool-question .treatment-tool-initial-que-ans").scrollIntoView({ 
          behavior: 'instant', 
          block: 'start' 
        });
      }
    },

    async sendAnswer(bodyData) {
      try {
          const response = await fetch(`https://alk-app.klarify.me/api/treatment-optimization-test`, {
              method: 'POST',
              headers: {
                  'Authorization': `Bearer ${window.klarifyAppToken}`,
                  'Accept': 'application/json',
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify(bodyData)
          });
          
          const res = await response.json();
          if(response.status == 200) {
              let pdfLink = res.link;
              let totResultId = res.tot_id;
              let externalId = this.TOTID_Cookie;
              let externalEmail = this.TOT_email;

              const CurrDate = new Date();
              const polandTime = new Date(
                CurrDate.toLocaleString("en-US", { timeZone: "Europe/Warsaw" })
              );
              const pad = (n) => n.toString().padStart(2, '0');
              const year = polandTime.getFullYear();
              const month = pad(polandTime.getMonth() + 1);
              const day = pad(polandTime.getDate());
              const hours = pad(polandTime.getHours());
              const minutes = pad(polandTime.getMinutes());
              const seconds = pad(polandTime.getSeconds());

              // Get Poland's UTC offset in minutes
              const offsetMinutes = -polandTime.getTimezoneOffset();
              const offsetSign = offsetMinutes >= 0 ? "+" : "-";
              const offsetHours = pad(Math.floor(Math.abs(offsetMinutes) / 60));
              const offsetMins = pad(Math.abs(offsetMinutes) % 60);

              // Format full date string
              const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMins}`;

              let callEvents = [
                {
                  "external_id": externalId,
                  "email": externalEmail,
                  "name": "web_cgr_tot_result_email",
                  "time": formattedDate,
                  "properties": {
                      "language": this.signupForm.querySelector('input[name="language"]').value,
                      "country": this.signupForm.querySelector('input[name="country"]').value,
                      "brand": this.signupForm.querySelector('input[name="brand"]').value,
                      "vas_score": this.answers[0].vas_score,
                      "q1": this.booleanAns[0],
                      "q2": this.booleanAns[1],
                      "q3": this.booleanAns[2],
                      "q4": this.booleanAns[3],
                      "q5": this.booleanAns[4],
                  }
                }
              ];

              // console.log('callEvents:');
              // console.log(callEvents);

              // console.log('res:');
              // console.log(res);
              let bodyDataMap = {
                  "external_id": externalId,
                  // "url": pdfLink,
                  "url_key": "tot_id",
                  "url_id": totResultId,
                  "newsletter_signup": this.newsletterSignupVal,
                  "events": callEvents,
              };
              // if(document.querySelector('#brazeFormMain .signup').classList.contains('d-none')){
                  this.sendPDFtoBraze(bodyDataMap); 
              // }                    
          }

      } catch (e) {
          console.error('Filter API call failed', e);
      }
  },
  async sendPDFtoBraze(bodyDataMap) {
    try {
        response = await fetch(`https://datahub-v2.klarify.me/api/general/pdf-url`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${window.datahubAPIKey}`,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(bodyDataMap)
            })
            if(response.status === 200){
                await response.json();
            }
    } catch (e) {
        console.error('Filter API call failed', e);
    }
  },
  setCookie(name, value, minutes) {
    let date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    let c_value = escape(value) + ((minutes == null) ? "" : "; expires=" + date.toUTCString() + "; path=/");
    document.cookie = name + "=" + c_value;

    return document.cookie;
  },
  getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        if (cookie.startsWith(name + '=')) {
            return cookie.substring(name.length + 1);
        }
    }
    return null; // Cookie not found
  }, 

  }

  window.treatmentTool.init();
}